export const cards: { [key: string]: any[] } = {
  en: [
    {
      type: "actions",
      id: 1,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "REINFORCEMENTS",
      subtitle: "REINFORCEMENTS",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "When *Reinforcements* rules are in effect, if the airfield is vacant, you may land an Infantry unit on it, at the cost of one order, when playing a *Direct from HQ* card.\nThis unit cannot move or attack this turn.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 2,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "BLOWING UP BRIDGES",
      subtitle: "BLOWING UP BRIDGES",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "**Option 1**\n- Play section card matching bridge’s section\n- Bridge is removed, card is lost and never replaced!\n\n**Option 2**\n- Play section card matching bridge’s section\n- Roll 2 dice: a star blows the bridge\n- Draw a replacement card, regardless of outcome",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 3,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "AIR STRIKE & BLITZ",
      subtitle: "AIR STRIKE & BLITZ",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "**Air Strikes**\n- When a player is capable of making air strikes, in conditions specified by the scenario, any *Recon 1* card he plays may be played as an *Air Power* card instead (*Air Sortie* if Air Pack rules are in effect).\n- The air strike must target at least one hex in the section designated on the *Recon 1* card played as the *Air Power*.\n\n**Blitz**\n- The Axis player can make air strikes at will when playing a *Recon 1* card.\n- Allied armor can move a maximum of 2 hexes and attack.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 4,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "FORWARD SPOTTING",
      subtitle: "FORWARD SPOTTING",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "When *Forward Spotting Artillery* rules are in effect, the player occupying specific scenario-defined hexes can use their artillery units like [Big Guns](troops-3).",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 5,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "COLLAPSIBLE RAFTS & BOATS",
      subtitle: "COLLAPSIBLE RAFTS & BOATS",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "- Available to infantry only\n- Unit in boat may move on [Rivers & Waterways](terrain-8), but must stop and may move no further on that turn\n- Unit in rafts & boats attack with 1 die penalty\n- Unit cannot retreat and loses 1 figure for each flag instead\n- When unit disembarks, boat may no longer be used",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 6,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SABOTAGE",
      subtitle: "SABOTAGE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "When *Sabotage* rules are in effect, a landmark ([dam](terrain-20), [factory](terrain-21), [power plant](terrain-34), etc.) can be demolished. Roll 2 dice at the start of any turn during which at least one of the saboteur’s unit is on the landmark. If the landmark is captured before the sabotage is completed, the count must be restarted from zero. Once the scenario-specified number of battle stars has been rolled, the landmark is demolished.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 7,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "FREEING PRISONERS",
      subtitle: "FREEING PRISONERS",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- When *Freeing Prisoners* rules are in effect, the unit capturing a [fortress](terrain-24), [prison camp](terrain-35) or other scenario-specified hex picks up the Prisoners represented by a battle star.\n- If a unit that frees up prisoners is eliminated, those are lost too!",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 8,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "HEROIC LEADER",
      subtitle: "HEROIC LEADER",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "When *Heroic Leader* rules are in effect:\n- Use a battle star to add a heroic leader to an infantry unit\n- Infantry unit with heroic leader may ignore one flag\n- Infantry unit with heroic leader attacks at +1 die\n- When infantry unit with heroic leader is eliminated, roll two dice. If at least 1 star is rolled, leader is lost and counts as a victory medal. If heroic leader survives, move him to nearest friendly Infantry unit.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 9,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "NORTH AFRICAN DESERT RULES",
      subtitle: "NORTH AFRICAN DESERT RULES",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "On successful close combat attack, armor may move into vacated hex and move 1 additional hex before attacking again.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 10,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "OASIS RECOVERY",
      subtitle: "OASIS RECOVERY",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- When *Oasis Recovery* rules are in effect, an ordered infantry with no adjacent enemy may recover lost figures. The unit cannot move or attack this turn.\n\n**Recovery**\n- Roll 1 die for each command card you have, including the one used to order the infantry. For each die matching the unit’s symbol or a star, 1 lost figure is returned to the unit. The unit may not gain more figures than it originally had.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 11,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "RADAR ALERT",
      subtitle: "RADAR ALERT",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "When *Radar Alert* rules are in effect, opponent cannot use an *Air Sortie* card (or equivalent) unless they first place it, face up on the board, at the end of the turn prior to which he wished to play it. Once on the board, the card **must** then be played the next turn.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 12,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CAPTURING EQUIPMENT",
      subtitle: "CAPTURING EQUIPMENT",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- When *Capturing Equipment* rules are in effect, a unit capturing a scenario-specified hex picks up the equipment represented by a battle star. To pick up the equipment, the unit capturing it must end its move on the specified hex.\n- If the unit is eliminated, the battle star representing the captured equipment is left in the hex where the unit was when it was eliminated.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 13,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SUPPLY TRAIN/REINFORCEMENTS",
      subtitle: "SUPPLY TRAIN/REINFORCEMENTS",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "When *Supply Train/Reinforcements* rules are in effect, when a [supply train](troops-6) reaches a [station](terrain-39), units on board may disembark onto adjacent hexes. They may not move or attack this turn.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 14,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "DESTROY SUPPLIES",
      subtitle: "DESTROY SUPPLIES",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "When *Destroy Supply* rules are in effect, destroying a [supply depot](terrain-43) using the [sabotage](actions-6) rules reduces movement of all enemy armor units by 1 hex.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 15,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "BLITZ RULES",
      subtitle: "BLITZ RULES",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Axis may play a *Recon 1* card as an *Air Power* card in same section: select a group of 4 or fewer adjacent enemy units and roll 1 die (Axis air attack) or 2 dice (Allied air attack) on each of them, ignoring terrain protection; flags cannot be ignored.\n- Allied armor moves 2 hexes max and Axis armor moves 3 hexes.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 16,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CAMOUFLAGE",
      subtitle: "CAMOUFLAGE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- A camouflaged unit may only be targeted in close combat.\n- A camouflaged unit that moves or attacks loses its camouflage.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 17,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CAPTURE HQ/SUPPLY TENT",
      subtitle: "CAPTURE HQ/SUPPLY TENT",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "When *Capture HQ/Supply Tent* rules are in effect, owner of captured [HQ/supply tent](terrain-56) immediately loses 1 random command card. If owner reclaims HQ/supply tent, they replenishes their hand.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 18,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "HOSPITAL RECOVERY",
      subtitle: "HOSPITAL RECOVERY",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- When *Hospital Recovery* rules are in effect, an ordered Infantry with no adjacent enemy may recover lost figures. The unit cannot move or attack this turn.\n\n**Recovery**\n- Roll 6 dice. For each die matching the unit’s symbol or star, 1 lost figure is returned to the unit. The unit may not gain more figures than it originally had.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 19,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "NIGHT ATTACKS",
      subtitle: "NIGHT ATTACKS",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![night](Actions Cards/73-Act19-Night Attacks_Attaques Nocturnes-M44PT.png)",
        B1: "**Use Night Visibility Chart**\n- Each turn Allied player rolls 4 dice, each star increases visibility.\n- When full daylight is reached, chart is set aside, normal visibility conditions resume.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 20,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "PARADROP",
      subtitle: "PARADROP",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "Drop all figures onto the board about 12 inches above the battlefield. If a figure lands...\n- On a free hex: complete it by adding do its hex the # of figures required to form a complete unit\n- On a hex of another friendly unit: put it in an adjacent free hex and complete it\n- On a hex with an enemy unit: put it in a an adjacent free hex, complete it, and the enemy unit immediately rolls a free attack against it (no taking ground allowed) \nIf a figure lands on an impassable hex, on a hex with other figure(s), or out of the board, it fails to land safely; remove the figure(s) at no medal cost\n- Off the board, or if there is no free adjacent hex to relocate it: the unit is removed at no medal cost",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 21,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SMOKE SCREEN",
      subtitle: "SMOKE SCREEN",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![night](Actions Cards/73-Act21-Smoke Screen_Ecran de fumee-M44EP.png)",
        B1: "- Place smoke screen markers on 3 adjacent contiguous hexes.\n- Once your turn has elapsed, flip smoke screen markers over.\n- Once your 2nd turn has elapsed, remove smoke screen markers.\n- Units can move on and through smoke screen without penalty.\n- Smoke screen blocks line of sight.\n- Unit on smoke screen hex may be seen and see out of that hex.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 22,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "ARMOR BREAKTHROUGH",
      subtitle: "ARMOR BREAKTHROUGH",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "- During a **single** game turn, you may order new armor units on the board.\n- Orders must be valid and issued as normal.\n- Units must enter through opponent’s baseline.\n- Units must stop on baseline hex; they may attack and take ground this turn, but cannot overrun.\n- When retreating, units must retreat toward controlling player’s baseline.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 23,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "EXIT MARKERS",
      subtitle: "EXIT MARKERS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![night](Actions Cards/73-Act23-Exit Markers_Pions Exit-M44WW.png)",
        B1: "- Markers with arrows pointing toward the players designate specific baseline hexes through which a unit exiting the board collects a medal.\n- Pairs or markers turned sideways designate a set of baseline hexes through which a unit exiting the board collects a medal; it includes the hexes with the markers.\n- When a unit successfully exits, place 1 of its figure on your victory track.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 24,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "RE-SUPPLY",
      subtitle: "RE-SUPPLY",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- When *Re-Supply* rules are in effect, any vehicle with this ability may re-supply any weakened adjacent friendly unit\n- Figures are exchanged 1 for 1, at no medal cost\n- Re-supplied unit cannot gain more figures than it had at game start\n- Supply vehicle and re-supplied unit(s) cannot attack this turn",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 25,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "COMBAT CARDS",
      subtitle: "COMBAT CARDS",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Standard or Breakthrough: deal 2 cards to each player\n- Overlord: deal 1 card to each Field General\n- Usually played side-by-side with command card, to enhance action of ordered unit(s)\n- Cards with a special action symbol such as *Street Fight* or *Bitter Resistance* may be played as that special action instead of card’s text\n- Increases to the number of of dice rolled, if any, are cumulative\n- No limit to the number of combat cards held or played during a turn; once played, discard\n- Draw a new combat card only at end of turn during which a *Recon* (but not a *Recon in Force*) was played\n- Reshuffle deck when *Their Finest Hour* is played",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 26,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "WINTER WEATHER",
      subtitle: "WINTER WEATHER",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Armor and vehicle move 2 hexes max\n- Taking ground and overruns are still possible, when applicable\n- If entire move is on a road, move 1 additional hex to a max of 3\n- Both Allied and Axis forces roll only 1 die when playing an *Air Power* card",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 27,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "REDUCED VISIBILITY",
      subtitle: "REDUCED VISIBILITY",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Dice symbols matching a unit’s symbol only score hits in close combat\n- Grenades still score hits as normal\n- Stars still score hits, when applicable\n- The *Barrage* Command card is unaffected, still scores hits on unit’s symbol",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 28,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "GROUND REINFORCEMENTS",
      subtitle: "GROUND REINFORCEMENTS",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "On each turn, after playing a command card, roll 1 die for each command card you have, including the one you just played. If the command card that you just played is a *Recon 1* card, roll 2 additional dice. Then look at the reinforcements table to see which type of units you may call in as reinforcements, if any.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 29,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "TOWN CONTROL",
      subtitle: "TOWN CONTROL",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![hexctrl](Actions Cards/73-Act29_30.png)",
        B1: "- When town control rules are in effect, and unless mentioned otherwise, any town hex that is occupied by a ground unit is marked with a control marker corresponding to the occupying unit (Axis or Allies).\n- If the unit vacates the hex or is eliminated, the control marker remains in place until an enemy ground unit occupies the hex, in which case the control marker is turned over.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 30,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "BEACH CONTROL",
      subtitle: "BEACH CONTROL",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![hexctrl](Actions Cards/73-Act29_30.png)",
        B1: "- When *beach control* rules are in effect, each controlled beach section of the battlefield (left, center, right) is a temporary victory medal objective.\r\n- A beach section is considered controlled by the landing forces if no enemy units occupy or are adjacent to any beach hex in the section.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 31,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SMOKE SHELLS",
      subtitle: "SMOKE SHELLS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![night](Actions Cards/73-Act21-Smoke Screen_Ecran de fumee-M44EP.png)",
        B1: "- Use Smoke Screen markers; place them on 3 adjacent contiguous hexes\n- Lasts 2 full turns: after opponent’s first turn, flip markers over; after opponent's second turn, remove them\n- Units moving into smoke shelled hex must stop\n- Units attack into and out of smoke shelled hexes with 1 die penalty\n- Block all line of sight, even for Artillery",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 32,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "BRIDGE CONTROL",
      subtitle: "BRIDGE CONTROL",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- When bridge control rules are in effect, the bridges indicated in the special rules will each are temporary medal objectives worth 1 medal when a unit has uncontested control of the bridge.\r\n- A bridge is uncontested when a unit is on the bridge or in an adjacent hex and there are no enemy units on the bridge or in any hex adjacent to it.\r\n- When one side gains control of a bridge, immediately remove the medal from the bridge hex and place it on the corresponding side’s medal stand.\r\n- If the bridge is no longer controlled by a unit because of movement, retreat, elimination, or if it becomes contested, the medal is immediately returned to the bridge.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 33,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "ENTRY MARKERS",
      subtitle: "ENTRY MARKERS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![entry](Actions Cards/73-Act33.png)",
        B1: "- When placed on the map with their arrows pointing into the battlefield, the entry markers designate specific hexes through which a reinforcement unit may enter the board to join the battle.\r\n- When turned sideways, a pair of entry markers designates a set of hexes through which a reinforcement unit may enter; this set includes the two hexes on which the entry markers are placed.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 34,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "AIR SUPERIORITY",
      subtitle: "AIR SUPERIORITY",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "When these rules are in effect, the scenario special rules will indicate which side has air superiority. When an *Air Power* card is played, the side with air superiority will roll 2 dice per hex, while the other side will only roll 1 die (regardless of the text on the *Air Power* command card). If you play with *New Flight Plan* rules, it overrules the air superiority chart.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 35,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "OFF-MAP ARTILLERY SUPPORT",
      subtitle: "OFF-MAP ARTILLERY SUPPORT",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "When off-map artillery support rules are in effect, any *Recon 1* command card may be played as a *Barrage* card instead. Target 1 enemy unit on the map. Roll 4 attack dice, ignoring any terrain reductions. Score 1 hit on unit symbol, grenade and star; flag(s) force unit to retreat and may not be ignored.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 36,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "MOLOTOV COCKTAILS",
      subtitle: "MOLOTOV COCKTAILS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![hexctrl](Actions Cards/73-Act36.png)",
        B1: "- When molotov cocktails rules are in effect for a side, it receives a define number of tokens.\r\n- These tokens are only available to infantry units, for close combat attacks only.\r\n- When used, state so before rolling the dice and immediately discard a token. For this close combat attack, stars rolled are considered hits.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 37,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SEALING CAVES",
      subtitle: "SEALING CAVES",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "After moving on a hex with a cave, a unit may, instead of attacking, try to seal the cave.\n- All adjacent hexes must be clear of enemy units to try to seal the cave.\n- The unit performs a close combat attack. The cave is successfully sealed if at least one star is rolled.\n- Once the cave is sealed, the hex becomes a regular [hill](terrain-6) or [mountain](terrain-30).",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "nations",
      id: 1,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "FRENCH RESISTANCE",
      subtitle: "FRENCH RESISTANCE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-res](Nations Cards/73-Natside_freefr.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- 3 figures only \r\n- Move 0-1 and attack, or move 2 and do not attack \r\n- Move onto any terrain and may still attack, but must still obey terrain movement restrictions \r\n- May ***take ground*** on successful close combat attack \r\n- May retreat 1 to 3 hexes per flag",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 2,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "RED ARMY (RKKA)",
      subtitle: "RED ARMY (RKKA)",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-ussr](Nations Cards/73-Natside_ussr.png)",
        B1: "**Russian Political Commissar**\n- A command card cannot be played directly from hand. Instead, it must be placed under the Commissar chip in preparation for a future turn.\n- *Recon 1*, *Counter-attack*, and *Ambush* cards are exceptions and may be played as normal.\n- Otherwise, the command card already under the Commissar chip is the player’s command card for the turn.",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 3,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "IMPERIAL JAPANESE ARMY",
      subtitle: "IMPERIAL JAPANESE ARMY",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![nat-ija](Nations Cards/73-Natside_japan.png)",
        B1: "**Yamato Damashi spirit** \r\n- Infantry must always ignore 1 flag \r\n- When on a terrain that ignores a flag, must ignore 2 flags instead \r\n- When in caves, must ignore all flags \r\n\r\n**Seishin Kyoiku doctrine** \r\n- Infantry at full strength in close combat attacks at +1 die \r\n\r\n**Banzai War cry** \r\n- Infantry may move 2 hexes to attack in close combat",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 4,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "US MARINE CORPS",
      subtitle: "US MARINE CORPS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-usmc](Nations Cards/73-Natside_usmc.png)",
        B1: "**Gung-Ho!**\n- Order 1 more unit than indicated on any section card played\n- All tactic cards that activate 1 to 4 units activate 2 to 5 instead\n- Marines counter-attack with +1 ordered unit against Japanese command card. Opposite not true.\n- No effect on *Air Power*, *Air Sortie*, *Artillery Bombard*, *Barrage*, *Close Assault*, *Infantry Assault*, and *Their Finest Hour*",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 5,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "BRITISH COMMONWEALTH FORCES (BCF)",
      subtitle: "BRITISH COMMONWEALTH FORCES (BCF)",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![nat-bcf](Nations Cards/73-Natside_bcf.png)",
        B1: "**Stiff Upper Lip** \r\n- A BCF ground unit that survives an enemy’s close combat attack without retreating and is down to a single figure may immediately battle back and attack that enemy back with 1 die \r\n- A battle back ignores all terrain dice reductions \r\n- A battle back may occur even if the close combat attack is part of an overrrun \r\n- The unit cannot battle back during an *Ambush*",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 6,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "ITALIAN ROYAL ARMY",
      subtitle: "ITALIAN ROYAL ARMY",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-ita](Nations Cards/73-Natside_italy.png)",
        B1: "**Italian High Command**\n- Start with 6 command cards; discard one for each unit lost, but never go below 3\n\n**Motorized Division**\n- All Italian ground units may retreat 1 to 3 hexes per flag\n\n**Artillery Bravery**\n- All Italian artillery units may ignore 1 flag",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 7,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "FRENCH ARMY",
      subtitle: "FRENCH ARMY",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-fra](Nations Cards/73-Natside_france.png)",
        B1: "**Furia Francese** \nAny French standard infantry unit that successfully eliminates an enemy unit or forces it to retreat following a close combat attack may: \n***take ground*** and not attack \n\n**or** \n\nStay in place and make a second close combat attack against another adjacent enemy unit. \nThis second attack is made with 1 die, ignoring any terrain dice reductions. The Infantry unit may ***take ground*** following the second attack, if eligible, but cannot attack again this turn.",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "swas",
      id: 1,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "SPECIAL WEAPON ASSETS",
      subtitle: "SPECIAL WEAPON ASSETS",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "- SWA badge or figure is placed with unit, removed when last figure is lost \r\n- Unit with SWA is treated as infantry, for all purposes \r\n- Unit with SWA may not ***take ground*** \r\n- SWA does not count as an additional medal",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 2,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "ANTI-TANK GUN",
      subtitle: "ANTI-TANK GUN",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-at](SWAs Cards/73-SWA_atgun.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Attacks like the infantry unit it equips \r\n- May only move **or** attack \r\n- Stars are hits on armor or vehicle",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 3,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "MORTAR",
      subtitle: "MORTAR",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-mort](SWAs Cards/73-SWA_mortar.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Attacks like the infantry unit it equips \r\n- May only move **or** attack \r\n- Ignores line of sight and terrain protections",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 4,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "SWAs – LATE WAR (> 1942)",
      subtitle: "SWAs – LATE WAR (> 1942)",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "- SWA badge or figure is placed with unit, removed when last figure is lost \n- Unit with SWA is treated as infantry, for all purposes \n- Unit with SWA may not ***take ground*** \n- SWA does not count as an additional medal",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 5,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "ANTI-TANK GUN (> 1942)",
      subtitle: "ANTI-TANK GUN (> 1942)",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-at](SWAs Cards/73-SWA_atgun.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Moves and attacks like the infantry unit it equips \r\n- In addition, if the unit has not moved, stars are hits on armor or vehicle",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 6,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "MORTAR (> 1942)",
      subtitle: "MORTAR (> 1942)",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-mort](SWAs Cards/73-SWA_mortar.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Moves and attacks like the infantry unit it equips \r\n- In addition, if the unit has not moved, range is increased to: \r\n![inf3211](Troops Cards/73-M44-Cards-troopattack_inf3211.png) \r\nand it ignores line of sight and terrain protections",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 7,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "MACHINE GUN (> 1942)",
      subtitle: "MACHINE GUN (> 1942)",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-mg](SWAs Cards/73-SWA_mg.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Moves and attacks like the infantry unit it equips \r\n- In addition, if the unit has not moved, stars are hits on infantry",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 8,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "MACHINE GUN",
      subtitle: "MACHINE GUN",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-mg](SWAs Cards/73-SWA_mg.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Attacks like the infantry unit it equips \r\n- May only move **or** attacks\r\n- Stars are hits on Infantry",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "terrain",
      id: 1,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BEACHES",
      subtitle: "BEACHES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter1-Beach_Plage-M44.png)",
        B1: "- Maximum movement onto a beach hex at any point of a turn is limited to 2 hexes.\n- A [hill](terrain-6) adjacent to a beach hex is considered a [sea bluff](terrain-11).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 2,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BUNKERS",
      subtitle: "BUNKERS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter2-Bunkers-M44.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag_b.png)",
        B1: "- Impassable to all units except infantry.\n- Units in a bunker may fire any direction.\n- Artillery and Armor starting in bunker may not retreat, must take a loss instead for each retreat not completed.\n- \\* Typically may be used as a defensive position by only one side (see scenario special rules).",
        B2: "![def](Terrains Cards/Def/arm-2_b.png)![def](Terrains Cards/Def/inf-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 3,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FORESTS",
      subtitle: "FORESTS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter3-Forests_Forets-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "*No additional special rules*",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 4,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "HEDGEROWS",
      subtitle: "HEDGEROWS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter4-Hedgerows_Bocage-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- To enter or take ground onto a hedgerow hex, unit **must start** its move from an adjacent hex.\n- When exiting, unit **must stop** on adjacent hex. Unit may still take ground, though.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 5,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "HEDGEHOGS",
      subtitle: "HEDGEHOGS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter5-Hedgehogs_Obstacles Antichars-M44.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Impassable to all units except infantry.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 6,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "HILLS",
      subtitle: "HILLS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter6-Hills_Collines-M44.png)",
        A2: "![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Height: 1**\n- \\* Only applies to units attacking from a lower height.\n- \\** Block line of sight, except between units that are at a height of 1 or higher.",
        B2: "![def](Terrains Cards/Def/arm-1_b.png)![def](Terrains Cards/Def/inf-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 7,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "OCEANS",
      subtitle: "OCEANS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter7-Oceans_Mer-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Units cannot attack when in ocean hex.\n- Units cannot retreat onto an ocean hex, must take a loss instead for each retreat not completed.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 8,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RIVERS & WATERWAYS",
      subtitle: "RIVERS & WATERWAYS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter8-Rivers_Rivieres-M44.png)",
        B1: "- Impassable to all units, except over [bridges](terrain-9).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 9,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BRIDGES",
      subtitle: "BRIDGES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter9-Bridges_Ponts-M44.png)",
        B1: "- Units may use bridges to enter a [river](terrain-8) hex.\n- Units may move onto a bridge from any adjacent land hex. Units on a bridge can only retreat to an adjacent land hex.\n- Units on a bridge ignore all effects of the underlying terrain.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 10,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "SANDBAGS",
      subtitle: "SANDBAGS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter10-Sandbags_Sac de Sables-M44.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "- If occupant leaves, the sandbag is removed.\n- Sandbags and terrain protections are not cumulative. Apply the higher attack dice reduction.",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 11,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CLIFFS & SEA BUFFS",
      subtitle: "CLIFFS & SEA BUFFS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter11-Cliffs Sea Bluffs_Falaises Escarpements-M44.png)",
        A2: "![IC](Terrains Cards/Icones/los_b.png)",
        B1: "- **Height: 1**\n- Moving up from/down to a beach is a 2 hex move for infantry; it is impossible for all other units.\n- Treat as a [hill](terrain-6) for movement from/to any other terrain type.\n- Treat as a [hill](terrain-6) for attack and retreat.\n- *Cliffs only* - Infantry may not take ground from a beach hex.\n- \\* Treat as a [hill](terrain-6) for line of sight and protections.",
        B2: "![def](Terrains Cards/Def/arm-1_b.png)![def](Terrains Cards/Def/inf-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 12,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "SEA WALL",
      subtitle: "SEA WALL",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter12-Sea Walls_Digue-M44.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Follow the same rules as [sandbags](terrain-10), except that the sea wall remains on the board even if the initial occupant leaves.",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 13,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "STEEP HILLS",
      subtitle: "STEEP HILLS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter6-Hills_Collines-M44.png)",
        A2: "![IC](Terrains Cards/Icones/los_b.png)",
        B1: "- **Height: 1**\n- Movement up onto a steep hill is a 2 hex move.\n- Units may take ground normally.\n- Movement down from a steep hill, or from steep hill to steep hill, is a 1 hex move.\n- \\* Treat as a [hill](terrain-6) for line of sight and protections.",
        B2: "![def](Terrains Cards/Def/inf-1_b.png)![def](Terrains Cards/Def/arm-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 14,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "TOWNS & VILLAGES",
      subtitle: "TOWNS & VILLAGES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter14-Towns Villages_Villes Villages-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Armor on a towns & villages hex attacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 15,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "WIRE",
      subtitle: "WIRE",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter15-Wire_Barbeles-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- In wire, Infantry attacks with a 1 die penalty.\n- Infantry may remove wire instead of attacking.\n- When moving (not retreating) onto wire, armor removes it and may still attack.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 16,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "AIRFIELDS",
      subtitle: "AIRFIELDS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter16-Airfields_Aerodrome-1-M44TP.png)",
        B1: "- When Air Pack rules are in effect, airplanes may take-off from, or land on, Airfields.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 17,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BARRACKS",
      subtitle: "BARRACKS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter17-Barracks_Baraquements-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Armor on a barracks hex attacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 18,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CEMETERIES",
      subtitle: "CEMETERIES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter18-Cemeteries_Cimetieres-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "*No additional special rules*",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 19,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CHURCHES",
      subtitle: "CHURCHES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter19-Churches_Eglises-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Armor on a church hex attacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 20,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "DAMS",
      subtitle: "DAMS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter20-Dams_Barrages-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Impassable to all units except infantry.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 21,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FACTORY COMPLEX",
      subtitle: "FACTORY COMPLEX",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter21-Factory Complex_Complexe Industriel-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Armor on a factory complex hex attacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 22,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FIELD BUNKERS",
      subtitle: "FIELD BUNKERS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter22-Field Bunkers_Casemate-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Impassable by armor and artillery,\n- Artillery and armor starting in a field bunker may not retreat, must take a loss instead for each retreat not completed.\n- Units in a field bunker may fire any direction.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 23,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FLOODED FIELDS",
      subtitle: "FLOODED FIELDS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter23-Flooded Fields_Champs Inondes-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt_b.png)",
        B1: "- To enter or take ground onto a flooded field hex, unit must start its move from an adjacent hex.\n- When exiting, unit must stop on adjacent hex. Unit may still take ground, though.\n- \\* Only applies to armor: armor cannot attack during the same turn it moves **in or out of** a flooded field. After an attack against a unit on a flooded field, armor may ***take ground***, but not perform an ***overrun***.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 24,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FORTRESSES",
      subtitle: "FORTRESSES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter24-Fortresses_Forteresses-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag_b.png)",
        B1: "- Impassable to to all units except infantry.\n- When *Freeing Prisoners* rules are in effect, refer to [Actions 7](actions-7). \n- \\* Unit in a fortress may ignore **all flags**.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 25,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "HIGH GROUND",
      subtitle: "HIGH GROUND",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter25-High Ground_Digues Hauteurs-M44TP.png)",
        B1: "- In Flooded Fields scenarios, high ground hexes are used to mark dry open ground that has the same effects as a standard grassland hex in a regular scenario. In addition, [hills](terrain-6), [roads](terrain-42), railways, [towns and villages](terrain-14) are all considered high ground.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 26,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "LAKES",
      subtitle: "LAKES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter26-Lake_Lacs-1-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los_b.png)",
        B1: "- Impassable to all units\n- \\* Two or more contiguous adjacent lake hexes block line of sight accross them.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 27,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "LIGHTHOUSES",
      subtitle: "LIGHTHOUSES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter27-Lighthouses_Phare-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Armor on a lighthouse hex attacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 28,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "MARSHES",
      subtitle: "MARSHES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter28-Marshes_Marecages-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt_b.png)",
        B1: "- Impassable to artillery\n- When exiting, unit must stop on adjacent hex. Unit may still take ground, though.\n- \\* Only applies to armor: armor cannot attack during the same turn it moves **in or out of** a marsh. After a battle against a unit on a marsh, armor may ***take ground***, but not perform an ***overrun***.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 29,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "MINEFIELDS",
      subtitle: "MINEFIELDS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter29-Minefields_Champs de Mines-1-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Randomly drawn from all minefield counters available and set up by controlling side before start of battle.\n- Friendly unit moving onto: counter is not revealed.\n- Enemy unit moving onto: counter is revealed; roll dice equal to counter value (flags are ignored). Decoy counters (value: 0) are removed; others remain, face up.\n- Retreating through/onto a counter does not trigger it.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 30,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "MOUNTAINS",
      subtitle: "MOUNTAINS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter30-Moutains_Montagnes-2-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Height: 2**\n- Impassable to all units except infantry.\n- Artillery starting on mountain attacks at: \n3/3/2/2/1/1/1\n- \\* Only applies to units attacking from a lower height.\n- \\** Block line of sight, except between units that are at a height of 2.",
        B2: "![def](Terrains Cards/Def/inf-2_b.png)![def](Terrains Cards/Def/arm-2_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 31,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "OASIS",
      subtitle: "OASIS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter31-Oasis-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- When *Oasis Recovery* rules are in effect, refer to [Actions 10](actions-10).",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 32,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PALM FORESTS",
      subtitle: "PALM FORESTS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter32-Palm Forests_Palmeraie-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "*No additional special rules*",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 33,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PONTOON BRIDGES",
      subtitle: "PONTOON BRIDGES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter33-Pontoon Bridges_Pont Flottant-M44TP.png)",
        B1: "- May only be built when specified in special rules of the scenario.\n- To build a pontoon bridge, play an “Attack” command card; instead of ordering 3 units, place a pontoon bridge on a [river](terrain-8) hex, in the section indicated by the Attack card.\n- Pontoon bridges follow the same rules as [bridges](terrain-9).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 34,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "POWER PLANTS",
      subtitle: "POWER PLANTS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter34-Power Plants_Centrale Electrique-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Armor on a power plant hex attacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 35,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PRISON CAMPS",
      subtitle: "PRISON CAMPS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter35-Prison Camps_Camp de Prisonniers-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Armor on a prison camp hex attacks with a 2 dice penalty.\n- When *Freeing Prisoners* rules are in effect, refer to [Actions 7](actions-7).",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 36,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RADAR STATIONS",
      subtitle: "RADAR STATIONS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter36-Radar Stations_Station Radar-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Armor on a radar station hexattacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 37,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RAILROAD BRIDGES",
      subtitle: "RAILROAD BRIDGES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter37-Railroad Bridges_Pont Ferroviaire-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop_b.png)",
        B1: "- \\* Only applies to armor and artillery (no movement restrictions for infantry). Armor may ***take ground*** and perform an ***overrun*** into/from a railroad bridge hex.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 38,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RAILROAD TRACKS",
      subtitle: "RAILROAD TRACKS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter38-Railroad Tracks_Voies Ferrees-2-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop_b.png)",
        B1: "- Road crossing a railroad track plays as standard [road](terrain-42).\n- \\* Only applies to armor and artillery (no movement restrictions for infantry). Armor may ***take ground*** and perform an ***overrun*** into/from a railroad tracks hex.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 39,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RAILROAD STATION",
      subtitle: "RAILROAD STATION",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter39-Railroad Station_Gare-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- A train moving into a railroad station does not have to stop.\n- Armor on a railroad station hex attacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 40,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ROAD BLOCKS",
      subtitle: "ROAD BLOCKS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter40-Road Blocks_Obstacle Routier-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Impassable to all units except infantry.",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 41,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FORDS AND FORDABLE RIVERS",
      subtitle: "FORDS AND FORDABLE RIVERS",
      titleSize: 1,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter41-Fords Fordable Rivers_Gues Riviers Gueables-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Units on a ford or a fordable river attack with a 1 die penalty.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 42,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ROADS",
      subtitle: "ROADS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter42-Roads_Routes-1-M44TP.png)",
        B1: "- Unit that starts its move on a road and stays on road hexes may move 1 additional hex.\n- For roads on hills, [hills](terrain-6) rules apply for terrain protection and line of sight.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 43,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "SUPPLY DEPOTS",
      subtitle: "SUPPLY DEPOTS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter43-Supply Depots_Depot de Ravitaillement-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)",
        B1: "- When *Destroy Supplies* rules are in effect, refer to [Actions 14](actions-14).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 44,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "WADIS & GULLIES",
      subtitle: "WADIS & GULLIES",
      titleSize: 2,
      template: 9,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter44-Wadis Gullies_Oueds Defiles-1-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Side slopes are impassable. Units may only move through open ends. \n- To attack a unit on this terrain, all units (except artillery) must be adjacent to it.\n- To attack from this terrain, the targeted unit must be adjacent.",
        B2: "![def](Terrains Cards/Def/art-1.png)",
        B3: "![def](Terrains Cards/Def/arm-1.png)\n![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 45,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CITY RUINS",
      subtitle: "CITY RUINS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter45-City Ruins_Ruines-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Impassable to all units except infantry.",
        B2: "![def](Terrains Cards/Def/inf-1.png)![def](Terrains Cards/Def/arm-2.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 46,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "DRAGON'S TEETH",
      subtitle: "DRAGON'S TEETH",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter46-Dragon s Teeth_Dents de Dragon-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Impassable to all units except infantry.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 47,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FROZEN RIVERS",
      subtitle: "FROZEN RIVERS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter47-Frozen River_Riviere Gelee-1-M44EF.png)",
        B1: "- Frozen rivers may be crossed, at a risk: after moving or retreating onto a frozen river hex, roll 2 dice; for each star rolled, the unit loses 1 figure.\n- A unit eliminated by crossing a frozen river counts as a medal for the other player.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 48,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "HILLS WITH FORESTS",
      subtitle: "HILLS WITH FORESTS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter48-Hills with Forest_Forets sur Collines-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- **Height: 1**",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 49,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "HILLS WITH VILLAGES",
      subtitle: "HILLS WITH VILLAGES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter49-Hills with Villages_Villages sur Collines-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- **Height: 1**\n- Armor on a hill with village hex attacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 50,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RAVINES",
      subtitle: "RAVINES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter50-Ravines_Ravins-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Impassable to all units except infantry.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 51,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "TRENCHES",
      subtitle: "TRENCHES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter51-Trenches_Tranchees-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/flag_b.png)",
        B1: "- Impassable to artillery,\n- Armor on a trenches hex cannot attack.\n- \\* Infantry may ignore one flag; armor may not.",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 52,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CAVE ON HILLS",
      subtitle: "CAVE ON HILLS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter52-Caves on Hills_Cavernes de Collines-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Height: 1**\n- Impassable to all units except infantry.\n- Japanese Infantry may move from a cave to any other empty cave hex (full turn move). When attacked, it **must** ignore **all** flags.\n- Allied Infantry moving onto this hex may, instead of attacking, try to [seal the cave](actions-37).\n- \\* Only applies to Japanese units. Regular [hills](terrain-6) protections apply for all other units.\n- \\** [Hills](terrain-6) rules apply for line of sight.",
        B2: "![def](Terrains Cards/Def/arm-2_b.png)![def](Terrains Cards/Def/inf-2_b.png)!",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 53,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CAVE ON MOUNTAINS",
      subtitle: "CAVE ON MOUNTAINS",
      titleSize: 2,
      fontSize: 3,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter53-Caves on Mountains_Cavernes de Montagnes-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Height: 2**\n- Impassable to all units except infantry.\n- Japanese Infantry may move from a cave to any other empty cave hex (full turn move). When attacked, it **must** ignore **all** flags.\n- Allied Infantry moving onto this hex may, instead of attacking, try to [seal the cave](actions-37).\n- \\* Only applies to Japanese units. Regular [mountains](terrain-30) protections apply for all other units.\n- \\** [Mountains](terrain-30) rules apply for line of sight.",
        B2: "![def](Terrains Cards/Def/arm-2_b.png)![def](Terrains Cards/Def/inf-2_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 54,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FISH PONDS",
      subtitle: "FISH PONDS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter54-Fish Ponds_Trous d eau-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)",
        B1: "- Impassable to artillery.\n- Infantry moving **onto** a fish pond hex cannot attack in the same turn.\n- Armor moving **onto or from** a fish pond hex cannot attack in the same turn.\n- When exiting, unit must stop on adjacent hex. Unit may still ***take ground***, though.\n- After attacking a unit on a fish pond, armor may ***take ground***, but not perform an ***overrun***.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 55,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "HOSPITALS",
      subtitle: "HOSPITALS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter55-Hospitals_Hopital-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)",
        B1: "- When *Hospital Recovery* rules are in effect, refer to [Actions 18](actions-18).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 56,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "HQS & SUPPLY TENTS",
      subtitle: "HQS & SUPPLY TENTS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter56-HQ Supply Tents_QG de campagne-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)",
        B1: "- When *Capture HQ/Supply Tent* rules are in effect, refer to [Actions 17](actions-17).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 57,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "JUNGLES",
      subtitle: "JUNGLES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter57-Jungles-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt_b.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- \\* Unit may attack after moving onto a jungle hex if it started its move in an adjacent hex. If armor starts its move on an adjacent hex and performs a successfull close combat attack on a unit in a jungle hex, it may ***take ground***, and perform an ***overrun***.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 58,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "LABOR CAMPS",
      subtitle: "LABOR CAMPS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter58-Labor Camps_Camp de Travail-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Armor on a labor camp hex attacks with a 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 59,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PIERS",
      subtitle: "PIERS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter59-Piers_Quai-M44PT.png)",
        B1: "- Movement onto a pier hex is only allowed from a land or beach hex, not an ocean hex.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 60,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RICE PADDIES",
      subtitle: "RICE PADDIES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter60-Rice Paddies_Rizieres-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt_b.png)",
        B1: "- Impassable to artillery.\n- When exiting, unit must stop on an adjacent hex. Unit may still ***take ground***, though.\n- \\* Only applies to armor: armor moving **onto or from** a rice paddies hex cannot attack in the same turn. After attacking a unit on a rice paddies hex, armor may ***take ground***, but not perform an ***overrun***.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 61,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FORDABLE STREAMS",
      subtitle: "FORDABLE STREAMS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter61-Fordable Streams_Ruisseaux et Rivieres Franchissables-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop_b.png)",
        B1: "- \\* Units moving onto a fordable stream hex must stop but may still ***take ground*** and perform an ***overrun***.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 62,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ROPE BRIDGES",
      subtitle: "ROPE BRIDGES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter62-Rope Bridges_Pont de Corde-M44PT.png)",
        B1: "- Units may use rope bridges to enter a [river](terrain-8) hex.\n- Pontoon bridges follow the same rules as [bridges](terrain-9).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 63,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ESCARPMENTS",
      subtitle: "ESCARPMENTS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter63-Escarpments_Escarpements Rocheux-M44MT.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)",
        B1: "- **Height: 1**\n- Impassable to all units.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 64,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ERGS & RIDGES",
      subtitle: "ERGS & RIDGES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter64-Ergs Ridges_Dunes-M44MT.png)",
        A2: "![IC](Terrains Cards/Icones/stop_b.png)![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Height: 1**\n- \\* Only applies to units moving/attacking from a lower height.\n- \\** Block line of sight, except between units that are at a height of 1 or higher.",
        B2: "![def](Terrains Cards/Def/arm-1_b.png)![def](Terrains Cards/Def/inf-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 65,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BALKAS",
      subtitle: "BALKAS",
      titleSize: 2,
      template: 9,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter65-Balkas-2-M44SS.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- When moving onto, or exiting, unit must stop and may move no further on that turn. \n- Unit may move out of a balka onto a bridge and vice versa, but must stop after doing so.\n- Unit on a balka hex attacks with 1 die penalty.",
        B2: "![def](Terrains Cards/Def/art-1.png)",
        B3: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 66,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ABATIS",
      subtitle: "ABATIS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter66-Abatis_Abattis-1-M44CB1.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Impassable to all units except infantry.\n- Infantry on a hex with an abatis attacks with 1 die penalty.\n- Infantry may remove abatis instead of attacking.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 67,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CASTLES",
      subtitle: "CASTLES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter67-Castle_Chateau-M44DD.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Armor on a castle hex attacks with 2 dice penalty.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 68,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "COASTLINES",
      subtitle: "COASTLINES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter68-Coastline_Littoral-1-M44MT.png)",
        B1: "- Maximum movement onto a coastline hex at any point of a turn is limited to 2 hexes.\n- A [hill](terrain-6) adjacent to a coastline hex is considered a [cliff](terrain-11).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "troops",
      id: 1,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "STANDARD UNITS",
      subtitle: "STANDARD UNITS",
      titleSize: 2,
      template: 1,
      slots: {
        A1: "**INFANTRY**\n![tro01a](Troops Cards/tro01a1.png)",
        A2: "**ARMOR**\n![tro01b](Troops Cards/tro01a2.png)",
        A3: "**ARTILLERY**\n![tro01c](Troops Cards/tro01a3.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png)\n- Move 0-1 and attack, or move 2 and do not attack\n- May ***take ground*** on successful close combat attack",
        B2: "![arm333](Troops Cards/73-M44-Cards-troopattack_arm333.png)\n- Move 0-3 and attack\n- May ***take ground*** on successful close combat attack an then make an ***overrun***",
        B3: "![art332211](Troops Cards/73-M44-Cards-troopattack_art332211.png)\n- Move 1 **or** attack\n- Ignore line of sight and terrain protections\n- Cannot take ground",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 2,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "SPECIALIZED UNITS",
      subtitle: "SPECIALIZED UNITS",
      titleSize: 2,
      template: 2,
      slots: {
        A1: "**ELITE INFANTRY**\n![tro02a](Troops Cards/tro02a1.png)",
        A2: "**ELITE ARMOR**\n![tro02b](Troops Cards/tro02a2.png)",
        B1: "- May move up to 2 hexes and still attack",
        B2: "- Starts with 4 tank figures per unit",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 3,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "BIG GUNS",
      subtitle: "BIG GUNS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro03](Troops Cards/tro03a1.png)",
        B1: "![art33221111](Troops Cards/73-M44-Cards-troopattack-art33221111.png)\n- Place cross-hair marker on target when hit is scored: the unit is zeroed-in. Marker stays until either the unit or the big gun moves. Zeroed-in units take fire at +1 in future rounds.\n- Cross-hair markers are not cumulative.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 4,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "COMBAT ENGINEERS",
      subtitle: "COMBAT ENGINEERS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro04](Troops Cards/tro04a1.png)",
        B1: "- Ignore all terrain protections in close combat\n- In wire, may attack with 1 die penalty **and** still remove the wire\n- In minefield, **must** clear the mines, instead of attacking\n- If ordered on *Infantry Assault*, may move 2 hexes and remove or clear mines",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 5,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TRAINS",
      subtitle: "TRAINS",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![tro05](Troops Cards/tro05a1.png)",
        B1: "- Ordered as a single unit\n- Move 1-3 hexes either way, along empty tracks\n- Retreat in opposite direction to locomotive’s travel\n- Train may ignore 1 flag\n- Hit on grenade symbol\n- Wagon destroyed on 3rd hit, locomotive on 4th hit",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 6,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "SUPPLY TRAINS",
      subtitle: "SUPPLY TRAINS",
      titleSize: 2,
      template: 5,
      slots: {
        A1: "- May carry infantry or armor reinforcement units\n- Units cannot attack while on train\n- When locomotive is at station, units may disembark on hexes adjacent to locomotive or wagon",
        A2: "![tro06](Troops Cards/tro06a2.png)",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 7,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "ARMORED TRAINS",
      subtitle: "ARMORED TRAINS",
      titleSize: 2,
      template: 5,
      slots: {
        A1: "Armored train carries one artillery piece on its wagon\n- Train may move **and** the Artillery can still attack\n- Artillery on wagon attacks like a regular artillery\n- Artillery on wagon is destroyed when wagon is destroyed (3 hits)",
        A2: "![tro07](Troops Cards/tro07a2.png)",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 8,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "CAVALRY",
      subtitle: "CAVALRY",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro08](Troops Cards/tro08a1.png)",
        B1: "![inf21](Troops Cards/73-M44-Cards-troopattack_inf21.png)\n- 4 figures\n- Ordered as infantry\n- Move 0-3 and attack\n- On successful close combat attack, may ***take tround*** and make an ***overrun***",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 9,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "SKI TROOPS",
      subtitle: "SKI TROOPS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro09](Troops Cards/tro09a1.png)",
        B1: "![inf32](Troops Cards/73-M44-Cards-troopattack_inf32.png)\n- 3 figures only\n- Move 0-3 and attack\n- Move onto any terrain and may still attack, but must still obey terrain movement restrictions\n- May retreat 1 to 3 hexes per flag",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 10,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "SNIPERS",
      subtitle: "SNIPERS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro10](Troops Cards/tro10a1.png)",
        B1: "![inf32](Troops Cards/73-M44-Cards-troopattack_inf11111.png)\n- 1 figure\n- Move 0-2 and attack; retreat 1 to 3 hex per flag\n- Move onto any terrain and may still attack, but must still obey terrain movement restrictions\n- May not target an armor unit\n- Hit enemy on symbol, grenade & star, ignore terrain protection\n- Sniper is only hit on grenade (& star exceptions)\n- Sniper does not count as victory medal",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 11,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "AIRCRAFT CARRIERS",
      subtitle: "AIRCRAFT CARRIERS",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![tro11](Troops Cards/tro11a1.png)",
        B1: "- When air rules are in effect, some airplanes may take-off from, or land on, aircraft carriers\n- Move 0-2 ocean hexes\n- Cannot move adjacent to beach\n- Is hit on grenade only; takes 3 hits to sink\n- May ignore 1 flag, takes hit if cannot retreat",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 12,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "DESTROYERS",
      subtitle: "DESTROYERS",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![tro012](Troops Cards/tro12a1.png)",
        B1: "![dest33221111](Troops Cards/73-M44-Cards-troopattack_dest33221111.png)\n- Move 0-2 ocean hexes and attack\n- Cannot move adjacent to beach\n- Is hit on grenade only; takes 3 hits to sink\n- May ignore 1 flag, takes hit if cannot retreat\n- Place cross-hair marker on hex of target when hit is scored. Until moved or destroyed, zeroed-in units take fire at +1 in future turns\n- Cross-hair markers are not cumulative",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 13,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "FLAME THROWER TANKS",
      subtitle: "FLAME THROWER TANKS",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![tro13](Troops Cards/tro13a1.png)",
        B1: "![arm333](Troops Cards/73-M44-Cards-troopattack_arm333.png)\n- Move 0-3 and attack\n- Terrain protection limited to 1 max in close combat",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 14,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "MOBILE ARTILLERY",
      subtitle: "MOBILE ARTILLERY",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro14](Troops Cards/tro14a1.png)",
        B1: "![art332211](Troops Cards/73-M44-Cards-troopattack-art33221111.png)\n- Move 0-1 and attack, or move 2 and do not attack\n- Ignore line of sight and terrain protection",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 15,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "LANDING CRAFT (LC)",
      subtitle: "LANDING CRAFT (LC)",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![tro15](Troops Cards/tro15a1.png)",
        B1: "- Start with embarked units\n- Move up to 2 hexes, but never onto hedgehogs\n- When landing on beach, remove LC, leave unit\n- Units in LC are targeted as usual, may retreat with LC on ocean hexes, cannot attack while in LC or after landing\n- If unit in LC is eliminated, LC is also removed but grants no additional medal",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 16,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TIGERS",
      subtitle: "TIGERS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro16](Troops Cards/tro16a1.png)",
        B1: "![arm333](Troops Cards/73-M44-Cards-troopattack_arm333.png)\n- 1 figure\n- Move 0-3 and attack\n- Enemy re-rolls all dice that scored a hit (including flags if the Tiger is unable to retreat). If at least one re-roll is a grenade, the Tiger is eliminated; all other re-rolls are ignored. If the Tiger is not destroyed, retreat rules apply normally for each flag of the first roll that was not re-rolled.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 17,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "SUPPLY TRUCKS",
      subtitle: "SUPPLY TRUCKS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro17](Troops Cards/tro17a1.png)",
        B1: "- 1-3 figures, per scenario\n- Treated as infantry, for all purposes\n- Move 0-2, +2 hexes when on a road, no attack\n- When ordered and adjacent to a weakened friendly unit, may [re-supply](actions-24) it",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 18,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "HALF-TRACKS",
      subtitle: "HALF-TRACKS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro18](Troops Cards/tro18a1.png)",
        B1: "![arm22](Troops Cards/73-M44-Cards-troopattack_arm22.png)\n- Move 0-2 and attack\n- 1-3 figures, per scenario\n- Treated as armor, for all purposes\n- On successful close combat attack, may ***take ground*** but cannot ***overrun***\n- When ordered and adjacent to a weakened friendly unit, may [re-supply](actions-24) it instead of attacking",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 19,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "LONG-RANGE PATROL CARS",
      subtitle: "LONG-RANGE PATROL CARS",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![tro19](Troops Cards/tro19a1.png)",
        B1: "![tru321](Troops Cards/73-M44-Cards-troopattack_tru321.png)\n- Move 0-4 and attack\n- 1-3 figures, per scenario\n- Treated as infantry, for all purposes\n- Enemy re-rolls all dice that scored a hit; for each grenade, the unit loses one car figure. All other re-rolls are ignored. Then, retreat rules apply normally for each flag of the first roll that was not re-rolled.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 20,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "COMMAND CARS",
      subtitle: "COMMAND CARS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro20](Troops Cards/tro20a1.png)",
        B1: "- Move 0-3, no attack\n- 1 figure\n- Treated as infantry, for all purposes\n- Enemy re-rolls all dice that scored a hit; if at least one re-roll is a grenade, the command car is eliminated; all other re-rolls are ignored\n- Order 1 more unit than indicated by section card when played in same section as command car\n- When command car is ordered by a ***Recon 1***, player may draw 1 command card from the discard pile at the end of their turn, instead of drawing 2 from the draw pile",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 21,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "BRANDENBURGERS",
      subtitle: "BRANDENBURGERS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro21](Troops Cards/tro21a1.png)",
        B1: "- 3 figures + 1 enemy figure\n- If hits are scored against Brandenburgers, opponent re-rolls a single die, looking for an Infantry symbol\n- If re-roll fails, initial roll is ignored and Brandenburgers take no casualties\n- If re-roll succeeds, enemy figure is removed & initial roll is applied as normal\n- When Brandenburgers are ordered to attack, remove the enemy figure from within\n- Brandenburgers with no enemy figure act like elite infantry",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 22,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "DEPLETED UNITS",
      subtitle: "DEPLETED UNITS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro22](Troops Cards/tro22a1.png)",
        B1: "- A depleted unit contains less figures than normal, per scenario\n- A depleted unit may never gain back more figures than it had at game start\n- A depleted unit moves and attacks as normal, but does not count as a medal when eliminated ox exiting the battlefield",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 23,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "HEAVY ANTI-TANK GUNS",
      subtitle: "HEAVY ANTI-TANK GUNS",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![tro23](Troops Cards/tro23a1.png)",
        B1: "![art2222](Troops Cards/73-M44-Cards-troopattack_art2222.png)\n- Move 0-1 **or** attack\n- Treated as artillery, for all purposes\n- stars hit on armor and vehicle\n- Ignore terrain protection\n- Require line of sight to target enemy unit",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 24,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TANK DESTROYERS",
      subtitle: "TANK DESTROYERS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro24](Troops Cards/tro24a1.png)",
        B1: "![arm2222](Troops Cards/73-M44-Cards-troopattack_arm2222.png)\n- Move 0-2 and attack\n- 3 figures (Germans and Russians 4)\n- Treated as armor, for all purposes\n- Is hit on star when attacked by units other than infantry\n- stars hit on armor and vehicle\n- When it does not move, ignore terrain protection\n- On successful close combat attack, may ***take ground*** but not ***overrun***\n- May retreat 1 to 2 hexes per flag",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 25,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "SCREAMING MEEMIES",
      subtitle: "SCREAMING MEEMIES",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro25](Troops Cards/tro25a1.png)",
        B1: "![art332211](Troops Cards/73-M44-Cards-troopattack-art33221111.png)\n- Move 0-1 **or **attack\n- At player's choice, fire incendiary or smoke shells; **incendiary shells:** flags cannot be ignored; **Smoke shells:** instead of attacking, place [smoke screen](actions-31) markers on up to 3 contiguously adjacent hexes within firing range\n- Never benefit from terrain protection\n- Ignore line of sight and terrain protection",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 26,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "HOBART’S FUNNIES",
      subtitle: "HOBART’S FUNNIES",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro26](Troops Cards/tro26a1.png)",
        B1: "- Move and attack like standard armor unit\r\n- Replace 1 tank figure with a Churchill & accessory of your choice. **Assault Bridge:** place [bridge](terrain-9) over [river](terrain-8) instead of attacking; **Bobbin:** ignore movement restrictions of [beach](terrain-1), [marsh](terrain-28) & [wire](terrain-15); when moving onto or through [wire](terrain-15), remove it; **Fascine:** ignore movement restrictions of [fords](terrain-41) & [trenches](terrain-51); may attack from [trenches](terrain-51); **Mine Digger:** must stop upon entering [minefield](terrain-29); remove it without detonating, and attack as normal; **Petard Mortar:** attack [bunker](terrain-2) with +1d when in close combat, if star is rolled, remove [bunker](terrain-2).",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 27,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "SUPPORTED INFANTRY",
      subtitle: "SUPPORTED INFANTRY",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro27](Troops Cards/tro27a1.png)",
        B1: "![supinf321](Troops Cards/73-M44-Cards-troopattack_supinf332.png)\n- 4 infantry figures + 1 armor figure\n- Treated as infantry, for all purposes\n- On a successful close combat attack, may ***take ground*** and perform a second close combat attack on an adjacent enemy unit.\n- On the unit’s third hit, the armor figure is removed and the unit permanently becomes a standard infantry unit.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 28,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "SUPPORTED ARMOR",
      subtitle: "SUPPORTED ARMOR",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro28](Troops Cards/tro28a1.png)",
        B1: "![suparm333](Troops Cards/73-M44-Cards-troopattack _suparm333.png)\n- 3 armor figures + 1 infantry figure\n- Treated as armor, for all purposes\n- For their close combat attacks, apply infantry dice reduction instead of armor’s\n- On the unit’s third hit, the infantry figure is removed and the unit permanently becomes a standard armor unit.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 29,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "JUNGLE FIGHTERS",
      subtitle: "JUNGLE FIGHTERS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro29](Troops Cards/tro29a1.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png)\n- Ignore [jungle](terrain-57) movement restrictions and terrain protection",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 30,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "POLISH DRAGOONS",
      subtitle: "POLISH DRAGOONS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro30](Troops Cards/tro30a1.png)",
        B1: "![inf32](Troops Cards/73-M44-Cards-troopattack_inf32.png)\n- 4 figures\n- Move 0-3 and attack\n- On successful close combat attack, may ***take tround*** and make an ***overrun***\n- May ignore 1 flag\n- May retreat 1 to 2 hexes per flag",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 31,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "ARMORED CAR",
      subtitle: "ARMORED CAR",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro31](Troops Cards/tro31a1.png)",
        B1: "![arm321](Troops Cards/73-M44-Cards-troopattack_arm321.png)\n- 1 figure\n- Move 0-4 hexes and attack\n- Treat as armor to order and in combat\n- On successful close combat attack, may ***take tround*** and make an ***overrun***\n- When attacked, treat as infantry\n- Enemy re-rolls all dice that scored a hit; if at least one re-roll is a grenade, the armored car is eliminated; all other re-rolls are ignored",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 32,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TANKETTE",
      subtitle: "TANKETTE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro32](Troops Cards/tro32a1.png)",
        B1: "![arm321](Troops Cards/73-M44-Cards-troopattack_arm321.png)\n- 2 figures\n- Treat as armor, for all purposes",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
  ],
  fr: [
    {
      type: "actions",
      id: 1,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "RENFORTS",
      subtitle: "RENFORTS",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "Lorque les règles de *renforts* s’appliquent, si un aérodrome est libre, vous pouvez y faire atterrir une unité d’infanterie pour le coût d’une activation lorsque vous jouez la carte *Ordre du QG*. Cette unité ne peut bouger ou combattre lors de ce tour.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 2,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "FAIRE SAUTER UN PONT",
      subtitle: "FAIRE SAUTER UN PONT",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "**Option 1**\r\n- Jouez une carte de *section* correspondant à celle du pont.\r\n- Le pont est retiré, la carte est perdue et jamais remplacée !\r\n\r\n**Option 2**\r\n- Jouez une carte de *section* correspondant à celle du pont.\r\n- Lancez 2 dés : une étoile détruit le pont, retirez-le.\r\n- Piochez normalement une nouvelle carte, quel que soit le résultat.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 3,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "RAIDS AÉRIENS & BLITZ",
      subtitle: "RAIDS AÉRIENS & BLITZ",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "**Raids aériens**\r\n- Lorsqu’un joueur bénéficie de *raids aériens*, dans des conditions spécifiées par le scénario, il peut jouer toute carte *Reconnaissance 1* comme une carte *Attaque aérienne* (*Sortie aérienne si les règles de l’Air Pack sont utilisées).\r\n- Cette *Attaque aérienne* doit viser au moins un hex de la section désignée par la carte *Reconnaissance 1*.\r\n\r\n**Blitz**\r\n- Le joueur des forces de l’Axe bénéficie de *raids aériens* à volonté quand il joue une carte *Reconnaissance 1*.\r\n- Les blindés des Alliés ne peuvent se déplacer que d’un maximum de 2 hex et combattre.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 4,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "REPÉRAGE POUR BOMBARDEMENT",
      subtitle: "REPÉRAGE POUR BOMBARDEMENT",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "Lorsque les règles de *repérage pour bombardement* s’appliquent, le joueur occupant un hex spécifique défini par le scénario peut utiliser son artillerie comme de l’[artillerie lourde](troops-3).",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 5,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CANOTS DÉMONTABLES & BATEAUX",
      subtitle: "CANOTS DÉMONTABLES & BATEAUX",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "- Réservé à l’infanterie uniquement.\r\n- Une unité embarquée peut entrer dans une [rivière](terrain-8) mais doit s’y arrêter ne plus bouger lors de ce tour.\r\n- Une unité embarquée subit un malus de 1 dé à ses attaques.\r\n- Une unité embarquée ne peut pas se replier et perd donc 1 figurine par drapeau.\r\n- Quand l’unité débarque, les bateaux ne peuvent plus être utilisés.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 6,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SABOTAGE",
      subtitle: "SABOTAGE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "Lorsque les règles de *sabotage* s’appliquent, un objectif ([barrage](terrain-20), [complexe industriel](terrain-21), [centrale électrique](terrain-34), etc.) peut être démoli. Lancez 2 dés au début de chaque tour durant lequel une unité du saboteur occupe ce terrain. Si le terrain est capturé avant la fin du sabotage, le compte doit est remis à zéro. Une fois que le nombre d’étoiles de bataille spécifié par le scénario a été obtenu, l’objectif est détruit.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 7,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "ÉVASION DE PRISONNIERS",
      subtitle: "ÉVASION DE PRISONNIERS",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Lorsque les règles d’*évasion de prisonniers* s’appliquent, une unité capturant une [forteresse](terrain-24), un [camp de prisonniers](terrain-35) out tout autre hex spécifié par le scénario prend en charge les prisonniers représentés par une étoile de bataille.\r\n- Si une unité libérant des prisonniers est éliminée, ceux-ci disparaissent également.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 8,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "COMMANDANT HÉROÏQUE",
      subtitle: "COMMANDANT HÉROÏQUE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "Lorsque les règles de *commandement héroïque* s’appliquent :\r\n- Utilisez une étoile de bataille pour l’ajouter à une unité d’infanterie.\r\n- Une unité d’infanterie qui en possède un peut ignorer 1 drapeau.\r\n- Une unité d’infanterie qui en possède un attaque à +1 dé.\r\n- Quand une unité d’infanterie qui en possède un est éliminée, lancez 2 dés : si au moins une étoile est obtenue, le commandant est perdu et compte comme une médaille de victoire. Si le commandant survit, déplacez-le dans l’unité d’infanterie la plus proche.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 9,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "RÈGLES DU DÉSERT NORD-AFRICAIN",
      subtitle: "RÈGLES DU DÉSERT NORD-AFRICAIN",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "Après une attaque en combat rapproché décisive, une unité blindée peut entrer dans l’hex libéré et encore se déplacer de 1 hex supplémentaire avant de combattre à nouveau.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 10,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SOINS DANS L’OASIS",
      subtitle: "SOINS DANS L’OASIS",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Lorsque les règles de *soins dans l’oasis* s’appliquent, une unité d’infanterie activée sans ennemi adjacent peut récupérer des figurines perdues. Cette unité ne peut bouger ou combattre lors de ce tour.\r\n\r\n**Récupération**\r\n- Lancez autant de dés que vous avez de cartes commandement, y compris celle utilisée pour activer l’infanterie. Pour tout symbole correspondant à l’unité et pour toute étoile, rajoutez une figurine à l’unité, sans dépasser le nombre initial de figurines.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 11,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "ALERTE RADAR",
      subtitle: "ALERTE RADAR",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "Lorsque les règles d’*alerte radar* s’appliquent, l’adversaire ne peut jouer une carte *sortie aérienne* (ou équivalente) que s’il le déclare à l’avance, en la posant face visible sur le plateau, à la fin du tour qui précède celui où elle sera jouée. Une fois placée sur le plateau, la carte *doit* être jouée au tour suivant.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 12,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CAPTURE D’ÉQUIPEMENT",
      subtitle: "CAPTURE D’ÉQUIPEMENT",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Lorsque les règles de *capture d’équipement* s’appliquent, une unité capturant un hex spécifié par le scénario prend en charge l’équipement représenté par une étoile de bataille. Pour prendre l’équipement, l’unité doit terminer son mouvement dans l’hex spécifié.\r\n- Si l’unité est détruite, l’étoile de bataille représentant l’équipement capturé est laissée sur l’hex dans lequel se trouvait l’unité lors de sa disparition.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 13,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "TRAIN DE RAVITAILLEMENT / RENFORTS",
      subtitle: "TRAIN DE RAVITAILLEMENT / RENFORTS",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "Lorsque les règles de *trains de ravitaillement / renforts* s’appliquent, quand le [train](troops-6) entre en  [gare](terrain-39), les unités à bord peuvent être déployées dans les hexs adjacents au train. Ces unités ne peuvent bouger ou combattre lors de ce tour.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 14,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "DESTRUCTION DE DÉPÔT",
      subtitle: "DESTRUCTION DE DÉPÔT",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "Lorsque les règles de *destruction de dépôt* s’appliquent, détruire un [dépôt](terrain-43) en utilisant les règles de [sabotage](actions-6) réduit le mouvement de toutes les unités blindées ennemies de 1 hex.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 15,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "RÈGLES DE BLITZ",
      subtitle: "RÈGLES DE BLITZ",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- L’Axe peut jouer une carte *Reconnaissance 1* comme une *Attaque aérienne* (*Sortie aérienne si vous jouez avec l’Air Pack) dans la section correspondante : désignez un groupe de 1 à 4 unités ennemies adjacentes les unes aux autres, lancez 1 dé (pour l’Axe) ou 2 dés (pour les Alliés) sur chaque hex en ignorant les protections de terrain ; les drapeaux ne peuvent pas être ignorés.\r\n- Les blindés alliés se déplacent de 2 hex maximum, ceux de l’Axe de 3 hex maximum.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 16,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CAMOUFLAGE",
      subtitle: "CAMOUFLAGE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Une unité camouflée ne peut être attaquée qu’en combat rapproché.\r\n- Une unité camouflée qui se déplace ou attaque perd son camouflage.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 17,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CAPTURE DU QG DE CAMPAGNE",
      subtitle: "CAPTURE DU QG DE CAMPAGNE",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "Lorsque les règles de *capture du [quartier général de campagne](terrain-56)* s’appliquent, si celui-ci est capturé, son propriétaire perd immédiatement 1 carte de commandement. Dès que le propriétaire reprend son [quartier général de campagne](terrain-56) à l’ennemi, il pioche une carte.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 18,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SOINS HOSPITALIERS",
      subtitle: "SOINS HOSPITALIERS",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Lorsque les règles de *soins hospitaliers* s’appliquent, une infanterie activée sur l’hôpital, sans ennemi adjacent, peut récupérer des figurines perdues. Cette unité ne peut bouger ou combattre lors de ce tour.\r\n\r\n**Récupérer des figurines**\r\n- Lancez 6 dés. Pour tout symbole correspondant à l’unité et pour toute étoile, rajoutez une figurine à l’unité, sans dépasser le nombre initial de figurines.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 19,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "ATTAQUES NOCTURNES",
      subtitle: "ATTAQUES NOCTURNES",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![night](Actions Cards/73-Act19-Night Attacks_Attaques Nocturnes-M44PT.png)",
        B1: "**Utilisez la carte de visibilité**\r\n- À chacun de ses tours, le joueur Allié lance 4 dés, chaque étoile obtenue augmente la visibilité.\r\n- Lorsque le jour est complètement levé, rangez la carte, les conditions normales de visibilité sont rétablies.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 20,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "PARACHUTAGE",
      subtitle: "PARACHUTAGE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "Pour chaque unité parachutée, prenez 1 figurine en main et lâchez-les ensemble à environ 30 cm au-dessus du plateau. Si une figurine atterrit :\r\n- sur un hex libre : ajoutez à son hex le nombre de figurines requis pour former une unité complète\r\n- en-dehors du plateau : l’unité est retirée de la bataille sans rapporter de médaille\r\n- sur un hex occupé par une unité amie : déplacez-la dans un hex adjacent et complétez l’unité\r\n- sur un hex occupé par une unité ennemie : déplacez-la dans un hex adjacent, complétez-la et l’unité ennemie bénéficie immédiatement d’une attaque gratuite contre elle (sans prise de terrain)\r\n- si aucun hex adjacent libre n’est disponible pour un déplacement, l’unité est retirée de la bataille sans rapporter de médaille",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 21,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "ÉCRAN DE FUMÉE",
      subtitle: "ÉCRAN DE FUMÉE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![night](Actions Cards/73-Act21-Smoke Screen_Ecran de fumee-M44EP.png)",
        B1: "- Placez les jetons d’écran de fumée sur trois hex adjacents.\r\n- Lorsque votre tour de jeu s’est écoulé, retournez-les.\r\n- Lorsque votre 2e tour de jeu s’est écoulé, retirez-les du plateau.\r\n- Une unité peut se déplacer dans et à travers un écran de fumée sans pénalité.\r\n- Un écran de fumée bloque la ligne de vue.\r\n- Une unité qui se trouve dans un hex où il y a un écran de fumée peut tout de même voir et être vu.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 22,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SOUTIEN BLINDÉ",
      subtitle: "SOUTIEN BLINDÉ",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "- *Une seule fois* pendant la partie, vous pouvez faire arriver de nouvelles unités blindées sur le champ de bataille.\r\n- Ces unités doivent être activées de façon normale, selon les règles.\r\n- Elles doivent arriver par un hex de la ligne de base ennemie et s’arrêter immédiatement. Elles peuvent combattre et faire une ***prise de terrain*** mais pas une ***percée***.\r\nSi ces unités sont forcées de battre en retraite, elles se replient vers la ligne de base du joueur qui les contrôle.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 23,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "PIONS EXIT",
      subtitle: "PIONS EXIT",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![night](Actions Cards/73-Act23-Exit Markers_Pions Exit-M44WW.png)",
        B1: "- Lorsque la flèche pointe vers le joueur, indique un hex spécifique par lequel une unité quittant le plateau rapporte une médaille.\r\n- Lorsqu’ils pointent l’un vers l’autre, indiquent un intervalle d’hex de bord de plateau par lequel une unité quittant le plateau rapporte une médaille.\r\n- Lorsqu’une unité quitte le plateau, son propriétaire remporte une médaille.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 24,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "RENFORCEMENT D’EFFECTIF",
      subtitle: "RENFORCEMENT D’EFFECTIF",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "- Lorsque les règles de *renforcement d’effectif* s’appliquent, tout véhicule en ayant la capacité peut *renforcer* une unité adjacente ayant subi des pertes.\r\n- Retirez autant de véhicules que vous ajoutez de figurines à l’unité que vous renforcez. L’adversaire ne remporte aucune médaille à cette occasion. Ni les véhicules de soutien, ni les unités renforcées ne peuvent combattre lors de ce tour.\r\n- Une unité ne peut pas être renforcée au-delà de son effectif initial.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 25,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CARTES COMBAT",
      subtitle: "CARTES COMBAT",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Standard ou Breakthrough : chaque joueur reçoit 2 cartes.\r\n- Overlord : chaque général reçoit 1 carte.\r\n- Se jouent principalement en combinaison avec une carte de commandement.\r\n- Les symboles *Combat de rue* ou *Ténacité* permettent une utilisation alternative de la carte.\r\n- Les bonus de dés fournis par une carte sont cumulatifs.\r\n- Pas de limite au nombre de cartes en main, ni au nombre de cartes jouées par tour. Toute carte jouée est défaussée.\r\n- Le seul moyen de récupérer une carte combat en fin de tour est de jouer une *Reconnaissance* (pas une *Reconnaissance en Force*).\r\n- Mélangez la pioche et la défausse lorsqu’une *Action héroïque* est jouée.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 26,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CHUTES DE NEIGE",
      subtitle: "CHUTES DE NEIGE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Les blindés et véhicules ne peuvent se déplacer que de 2 hex maximum.\r\n- Ils peuvent toute de même faire une ***prise de terrain*** ou une ***percée***.\r\n- Si l’intégralité de leur mouvement se fait sur route, ils peuvent se déplacer d’un hex supplémentaire, pour un maximum de 3 hex.\r\n- Les Alliés, comme l’Axe, ne lancent plus qu’un dé par hex en cas d’*Attaque aérienne*.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 27,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "VISIBILITÉ RÉDUITE",
      subtitle: "VISIBILITÉ RÉDUITE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Les symboles du dé correspondant à l’unité ciblée ne sont pris en compte qu’en cas de combat rapproché.\r\n- La grenade est prise en compte dans tous les cas.\r\n- Lorsque l’étoile provoque une perte, elle compte aussi dans tous les cas.\r\n- La carte *Tir de Barrage* n’est pas affectée.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 28,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "RENFORTS TERRESTRES",
      subtitle: "RENFORTS TERRESTRES",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "À chaque tour, après avoir joué une carte de commandement, lancez autant de dés que vous avez de cartes de commandement (y compris celle que vous venez de jouer). Lancez 2 dés de plus si la carte que vous venez de jouer est une *Reconnaissance 1*. Consultez ensuite le tableau des renforts pour savoir quelle(s) unité(s) vous pouvez appeler en renfort.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 29,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CONTRÔLE DE VILLAGE",
      subtitle: "CONTRÔLE DE VILLAGE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![hexctrl](Actions Cards/73-Act29_30.png)",
        B1: "- Lorsque les règles de *contrôle de village* s'appliquent, et sauf mention contraire dans les règles spéciales, tout hex de village occupé par une unité est marqué d'un jeton de contrôle du camp approprié (Axe ou Alliés).\r\n- Si l'unité quitte l'hex ou est éliminée, le jeton de contrôle reste en place jusqu'à ce qu'une unité ennemie s'empare de l'hex où il se trouve. Dans ce cas, le jeton est retourné du côté de son nouveau propriétaire.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 30,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CONTRÔLE DE PLAGE",
      subtitle: "CONTRÔLE DE PLAGE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![hexctrl](Actions Cards/73-Act29_30.png)",
        B1: "- Lorsque les règles de *contrôle de plage* s'appliquent, chaque section de plage du plateau (gauche, centre et droite) sous contrôle rapporte une médaille-objectif temporaire.\r\n- Une section de plage est considérée comme sous contrôle par le camp qui débarque si aucune unité ennemie n'est présente sur un hex de plage ou sur un hex adjacent à la plage de cette section.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 31,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "OBUS FUMIGÈNES",
      subtitle: "OBUS FUMIGÈNES",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![night](Actions Cards/73-Act21-Smoke Screen_Ecran de fumee-M44EP.png)",
        B1: "- Utilisez les jetons d’écran de fumée : placez-les sur trois hex adjacents.\r\n- Durent 2 tours complets : après que chaque joueur a joué un 1er tour, retournez les marqueurs ; chaque joueur joue encore un tour, puis ils sont retirés.\r\n- Une unité entrant dans un hex avec des fumigènes **doit** s’arrêter.\r\n- Une unité qui attaque depuis / vers un hex avec des fumigènes subit un malus de 1 dé à ses attaques.\r\n- Les fumigènes bloquent la ligne de vue, y compris pour l’artillerie.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 32,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "CONTRÔLE DE PONT",
      subtitle: "CONTRÔLE DE PONT",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "- Lorsque les règles de *contrôle de pont* s'appliquent, les ponts indiqués dans les règles spéciales du scénario rapportent chacun une médaille-objectif temporaire quand ils sont sous contrôle.\r\n- Un pont est sous contrôle à partir du moment où une unité se trouve dessus ou dans un hex adjacent ET si aucune unité ennemie ne se trouve sur le pont ou dans un hex adjacent au pont.\r\n- Lorsqu'un camp prend le contrôle d'un pont, retirez la médaille qui se trouve dessus et placez-la sur le tableau des médailles du joueur qui a pris le contrôle du pont.\r\n- Si l'unité qui contrôlait le pont se déplace, bat en retraite ou est éliminée, ou si une unité ennemie vient contester le contrôle du pont, alors la médaille y est immédiatement replacée.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 33,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "PIONS ENTRY",
      subtitle: "PIONS ENTRY",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![entry](Actions Cards/73-Act33.png)",
        B1: "- Quand il est placé avec la flèche pointant vers le bord du plateau, un pion entry indique un hex spécifique par lequel une unité de renfort peut rejoindre la bataille.\r\n- Lorsqu'ils sont tournés de côté, les pions entry indiquent un intervalle d'hex de bord de plateau par lequel une unité de renforts peut rejoindre la bataille. Cet intervalle inclut les deux hex sur lesquels sont placés les pions entry.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 34,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SUPÉRIORITÉ AÉRIENNE",
      subtitle: "SUPÉRIORITÉ AÉRIENNE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "Lorsque les règles de *supériorité Aérienne* s'appliquent, les règles spéciales du scénario indiquent quel joueur dispose de la supériorité aérienne. Lorsque ce joueur joue une carte *Attaque aérienne*, il lance 2 dés par hex visé, contre un seul pour son adversaire (cette règle a priorité sur le texte de la carte *Attaque aérienne*). Si vous jouez avec les règles de *New Flight Plan*, elle supplante l’information livrée par le tableau de supériorité aérienne.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 35,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "SOUTIEN D’ARTILLERIE HORS-CARTE",
      subtitle: "SOUTIEN D’ARTILLERIE HORS-CARTE",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "Lorsque les règles de *soutien d'artillerie hors-carte* s'appliquent, toute carte *Reconnaissance 1* peut être jouée comme un *Tir de barrage* : ciblez 1 unité ennemie. Lancez 4 dés en ignorant les protections de terrain. Tout symbole correspondant à l'unité visée, toute grenade et toute étoile infligent une perte. Les drapeaux ne peuvent pas être ignorés.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 36,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "COKTAILS MOLOTOV",
      subtitle: "COKTAILS MOLOTOV",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![hexctrl](Actions Cards/73-Act36.png)",
        B1: "Lorsque les règles de *cocktails molotov* s’appliquent pour un camp, celui-ci reçoit un certain nombre de jetons dédiés.\r\n- Ces jetons ne peuvent être utilisés que par l’infanterie en combat rapproché.\r\n- Lorsque vous voulez utiliser un cocktail molotov, annoncez-le et défaussez un jeton avant de lancer vos dés d’attaque. Pour cette attaque en combat rapproché, chaque étoile obtenue inflige une perte.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "actions",
      id: 37,
      background: "Actions Cards/73-M44V2-Cards-Helpers-ActionsCards.png",
      title: "COMBLER UNE CAVERNE",
      subtitle: "COMBLER UNE CAVERNE",
      titleSize: 2,
      template: 6,
      slots: {
        A1: "Après s’être déplacée sur un hex avec une caverne, une unité peut, au lieu d’attaquer, tenter de la combler.\r\n- Pour ce faire, aucune unité ennemie ne doit être présente dans les hex adjacents à celui de la caverne.\r\n- L’unité effectue une attaque en combat rapproché. La caverne est comblée si au moins une étoile est obtenue.\r\n- Une fois la caverne comblée, l’hex devient une [colline](terrain-6) ou une [montagne](terrain-30) normale.",
      },
      titleBackground:
        "Actions Cards/73-M44V2-Cards-Helpers-CartoucheActions.png",
    },
    {
      type: "nations",
      id: 1,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "RÉSISTANCE FRANÇAISE",
      subtitle: "RÉSISTANCE FRANÇAISE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-res](Nations Cards/73-Natside_freefr.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- 3 figurines\r\n- Se déplace de 0-1 hex et attaque ou se déplace de 2 hex sans attaquer.\r\n- Ignore les restrictions de terrains empêchant une unité d’attaquer après y être entré (mais les restrictions de déplacement s’appliquent toujours).\r\n- Peut effectuer une ***prise de terrain*** après une attaque en combat rapproché décisive.\r\n- Peut se replier de 1 à 3 hex par drapeau.",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 2,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "ARMÉE ROUGE (RKKA)",
      subtitle: "ARMÉE ROUGE (RKKA)",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-ussr](Nations Cards/73-Natside_ussr.png)",
        B1: "**Commissaire Politique russe**\r\n- Une carte de commandement ne peut être jouée directement depuis la main. Au lieu de cela, elle doit être placée sous le jeton du commissaire en préparation d’un tour à venir.\r\n- Les cartes *Reconnaissance 1*, *Contre-attaque*, et *Embuscade* sont des exceptions, elles peuvent être jouées normalement.\r\n- Sinon, la carte de commandement se trouvant sous le jeton du commissaire est la carte du joueur pour le tour.",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 3,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "ARMÉE IMPÉRIALE JAPONAISE",
      subtitle: "ARMÉE IMPÉRIALE JAPONAISE",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![nat-ija](Nations Cards/73-Natside_japan.png)",
        B1: "**Concept du Yamato Damashi**\r\n- L’infanterie **doit** toujours ignorer un drapeau. \r\n- L’infanterie **doit** en ignorer 2 lorsque le terrain permet d’ignorer 1 drapeau.\r\n- L’infanterie dans une caverne **doit** ignorer tous les drapeaux. \r\n\r\n**Doctrine de Seishin Kyoiku**\r\n- L’infanterie ayant toutes ses figurines attaque avec 1 dé supplémentaire en combat rapproché.\r\n\r\n**Cri de guerre Banzai !**\r\n- L’infanterie peut se déplacer de 2 hex et attaquer si elle est en combat rapproché.",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 4,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "CORPS DES US MARINES",
      subtitle: "CORPS DES US MARINES",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-usmc](Nations Cards/73-Natside_usmc.png)",
        B1: "**Gung-Ho!**\n- Activez 1 unité de plus que le nombre indiqué par une carte section jouée.\n- Toutes les cartes tactiques qui activent de 1 à 4 unités en activent de 2 à 5.\n- Les Marines contre-attaquent avec 1 unité supplémentaire activée contre les cartes de commandement japonaises. L’inverse n’est pas vrai.\n- Aucun effet avec les cartes *Attaque / Sortie aérienne*, *Tir d’artillerie*, *Tir de barrage*, *Combat rapproché**, *Assaut d’infanterie* et *Action héroïque*.",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 5,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "FORCES BRITANNIQUES DU COMMONWEALTH (BCF)",
      subtitle: "FORCES BRITANNIQUES DU COMMONWEALTH (BCF)",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![nat-bcf](Nations Cards/73-Natside_bcf.png)",
        B1: "**Le Flegme britannique**\r\n- Si une unité terrestre du BCF est attaquée en combat rapproché et réduite à une seule figurine, et si elle ne s’est pas repliée, elle peut immédiatement riposter avec un dé.\r\n- Une riposte ignore les protections des terrains.\r\n- Il est possible de riposter même si l’attaque en combat rapproché est réalisée dans le cadre d’une ***percée***.\r\n- Il n’est pas possible de riposter contre une *Embuscade*.",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 6,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "ARMÉE ROYALE ITALIENNE",
      subtitle: "ARMÉE ROYALE ITALIENNE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-ita](Nations Cards/73-Natside_italy.png)",
        B1: "**Haut Commandement Italien**\r\n- Commencez avec 6 cartes de commandement et défaussez-en une à chaque fois que vous perdez une unité (jusqu’à un minimum de 3 cartes).\r\n\r\n**Divisions motorisées**\r\n- Toute unité terrestre italienne peut se replier de 1 à 3 hex par drapeau.\r\n\r\n**La Bravoure des artilleurs**\r\n- Toute unité d’artillerie italienne peut ignorer 1 drapeau.",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "nations",
      id: 7,
      background: "Nations Cards/73-Compendium-NationsCards.png",
      title: "ARMÉE FRANÇAISE",
      subtitle: "ARMÉE FRANÇAISE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![nat-fra](Nations Cards/73-Natside_france.png)",
        B1: "**Furia Francese**\r\nToute unite d’infanterie standard qui élimine une unité ennemie ou la force à se replier suite à un combat rapproché peut :\r\nfaire une ***prise de terrain*** classique\r\n\r\n**ou**\r\n\r\nrester sur place et attaquer en combat rapproché une autre unite adjacente.\r\nCette seconde attaque est résolue avec un seul dé et les protections du terrain sont ignorées. Elle peut donner lieu à une ***prise de terrain***, mais pas à une nouvelle attaque.",
      },
      titleBackground: "Nations Cards/73-Compendium-NationsCards-Cartouche.png",
    },
    {
      type: "swas",
      id: 1,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "RÈGLES DE MATÉRIEL",
      subtitle: "RÈGLES DE MATÉRIEL",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "- Le matériel est placé avec l’unité qui en dispose et retiré lorsque l’unité est éliminée.\r\n- Une unité avec du matériel est considérée comme de l’infanterie dans tous les cas.\r\n- Une unité avec du matériel ne peut pas faire de ***prise de terrain***.\r\n- Le matériel ne rapporte pas de médaille supplémentaire.",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 2,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "ARME ANTICHAR",
      subtitle: "ARME ANTICHAR",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-at](SWAs Cards/73-SWA_atgun.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png)\r\n- Se déplace **ou** attaque.\r\n- Attaque comme l’infanterie qui l’accompagne.\r\n- L’unité inflige une perte sur étoile quand elle attaque une unité blindée ou de véhicules.",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 3,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "MORTIER",
      subtitle: "MORTIER",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-mort](SWAs Cards/73-SWA_mortar.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Se déplace **ou** attaque.\r\n- Attaque comme l’infanterie qui l’accompagne.\r\n- Ignore les lignes de vue et les protections des terrains.",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 4,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "RÈGLES DE MATÉRIEL (> 1942)",
      subtitle: "RÈGLES DE MATÉRIEL (> 1942)",
      titleSize: 1,
      template: 6,
      slots: {
        A1: "- Le matériel est placé avec l’unité qui en dispose et retiré lorsque l’unité est éliminée.\r\n- Une unité avec du matériel est considérée comme de l’infanterie dans tous les cas.\r\n- Une unité avec du matériel ne peut pas faire de ***prise de terrain***.\r\n- Le matériel ne rapporte pas de médaille supplémentaire.",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 5,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "ARME ANTICHAR (> 1942)",
      subtitle: "ARME ANTICHAR (> 1942)",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![swa-at](SWAs Cards/73-SWA_atgun.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Lorsque l’unité se déplace, attaque comme l’infanterie qui l’accompagne.\r\n- Lorsque l’unité ne se déplace pas, inflige une perte sur étoile quand elle attaque une unité blindée ou de véhicules.",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 6,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "MORTIER (> 1942)",
      subtitle: "MORTIER (> 1942)",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-mort](SWAs Cards/73-SWA_mortar.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Lorsque l’unité se déplace, attaque comme l’infanterie qui l’accompagne.\r\n- Lorsque l’unité ne se déplace pas, sa porté devient :\r\n![inf3211](Troops Cards/73-M44-Cards-troopattack_inf3211.png) \r\net elle ignore les lignes de vue et les protections des terrains.",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 7,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "MITRAILLEUSE (> 1942)",
      subtitle: "MITRAILLEUSE (> 1942)",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-mg](SWAs Cards/73-SWA_mg.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Lorsque l’unité se déplace, attaque comme l’infanterie qui l’accompagne.\r\n- Lorsque l’unité ne se déplace pas, inflige une perte sur étoile quand elle attaque une unité d’infanterie.",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "swas",
      id: 8,
      background: "SWAs Cards/73-Compendium-SWAsCards.png",
      title: "MITRAILLEUSE",
      subtitle: "MITRAILLEUSE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![swa-mg](SWAs Cards/73-SWA_mg.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png) \r\n- Se déplace **ou** attaque.\r\n- Attaque comme l’infanterie qui l’accompagne.\r\n- L’unité inflige une perte sur étoile quand elle attaque une unité d’infanterie.",
      },
      titleBackground: "SWAs Cards/73-Compendium-SWAsCards-Cartouche-Type1.png",
    },
    {
      type: "terrain",
      id: 1,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PLAGES",
      subtitle: "PLAGES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter1-Beach_Plage-M44.png)",
        B1: "- Entrer dans un hex de plage limite le déplacement maximal d’une unité à 2 hex pour le tour en cours.\r\n- Une [colline](terrain-6) adjacente à un hex de plage est considéré comme un [escarpement](terrain-11).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 2,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BUNKERS",
      subtitle: "BUNKERS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter2-Bunkers-M44.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag_b.png)",
        B1: "- Infranchissables pour toutes les unités sauf l’infanterie.\r\n- Les unités dans un bunker peuvent tirer dans toutes les directions.\r\n- Les blindés et artilleries qui débutent dans un bunker ne peuvent pas se replier ; chaque drapeau qui n’est pas ignoré leur inflige une perte.\r\n- \\* En général, n’est utilisable comme position défensive que par un seul camp (indiqué dans les règles spéciales du scénario).",
        B2: "![def](Terrains Cards/Def/arm-2_b.png)![def](Terrains Cards/Def/inf-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 3,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FORÊTS",
      subtitle: "FORÊTS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter3-Forests_Forets-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "*Pas de règle spéciale supplémentaire*",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 4,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BOCAGES",
      subtitle: "BOCAGES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter4-Hedgerows_Bocage-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Pour se déplacer, ou faire une prise de terrain sur un hex de bocage, une unité **doit avoir démarré** son tour sur un hex adjacent.\r\n- Une unité qui quitte un hex de bocage **doit s’arrêter** dans l’hex adjacent qu’il a rejoint et arrêter son déplacement pour ce tour. La prise de terrain reste toutefois possible.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 5,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "OBSTACLES ANTICHARS",
      subtitle: "OBSTACLES ANTICHARS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter5-Hedgehogs_Obstacles Antichars-M44.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Infranchissables pour toutes les unités sauf l’infanterie.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 6,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "COLLINES",
      subtitle: "COLLINES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter6-Hills_Collines-M44.png)",
        A2: "![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Hauteur : 1**\r\n- \\* S’applique uniquement aux unités situées plus bas.\r\n- \\** Bloque la ligne de vue, sauf entre les unités se trouvant sur une hauteur de 1 ou plus.",
        B2: "![def](Terrains Cards/Def/arm-1_b.png)![def](Terrains Cards/Def/inf-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 7,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "OCÉAN",
      subtitle: "OCÉAN",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter7-Oceans_Mer-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Les unités sur un hex d’océan ne peuvent pas attaquer.\r\n- Les unités ne peuvent pas se replier vers un hex d’océan et doivent subir à la place une perte pour chaque symbole retraite obtenu contre elles.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 8,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FLEUVES & RIVIÈRES",
      subtitle: "FLEUVES & RIVIÈRES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter8-Rivers_Rivieres-M44.png)",
        B1: "- Infranchissables pour toutes les unités, sauf en utilisant un [pont](terrain-9).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 9,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PONTS",
      subtitle: "PONTS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter9-Bridges_Ponts-M44.png)",
        B1: "- Les unités peuvent utiliser un pont pour entrer sur un hex de [fleuve ou rivière](terrain-8).\r\n- Les unités peuvent se déplacer sur un pont depuis n’importe quel hex de terre ferme adjacent. Les unités sur un pont ne peuvent se replier que vers un hex de terre ferme.\r\n- Les unités sur un pont ignorent les effets de l’hex de terrain se trouvant en dessous.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 10,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "SACS DE SABLE",
      subtitle: "SACS DE SABLE",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter10-Sandbags_Sac de Sables-M44.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Si l’unité qui l’hex contenant des sacs de sable, ces derniers sont retirés du plateau. \r\n- Les protections des sacs de sable et du terrain ne se cumulent pas. Appliquez la plus élevée des deux.",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 11,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ESCARPEMENTS & FALAISES",
      subtitle: "ESCARPEMENTS & FALAISES",
      titleSize: 1,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter11-Cliffs Sea Bluffs_Falaises Escarpements-M44.png)",
        A2: "![IC](Terrains Cards/Icones/los_b.png)",
        B1: "- **Hauteur : 1**\r\n- Un déplacement vers ces terrains depuis un hex de plage (et inversement) coûte 2 hex de déplacement pour une infanterie ; ce déplacement est impossible pour les autres unités.\r\n- Considérés comme des [collines](terrain-6) pour les déplacements vers / depuis tout autre type de terrain. \r\n- Considérés comme des [collines](terrain-6) pour l’attaque et la retraite.\r\n- *Falaises seulement :* l’infanterie ne peut pas y faire de prise de terrain si elle vient d’un hex de plage. \r\n- \\* Considérés comme des [collines](terrain-6) pour les lignes de vue et les protections.",
        B2: "![def](Terrains Cards/Def/arm-1_b.png)![def](Terrains Cards/Def/inf-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 12,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "DIGUES",
      subtitle: "DIGUES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter12-Sea Walls_Digue-M44.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Suivent les mêmes règles que les [sacs de sable](terrain-10) mais elles restent sur le plateau après qu’une unité quitte un hex de digue.",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 13,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "COLLINES ESCARPÉES",
      subtitle: "COLLINES ESCARPÉES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter6-Hills_Collines-M44.png)",
        A2: "![IC](Terrains Cards/Icones/los_b.png)",
        B1: "- **Hauteur : 1**\r\n- Entrer sur cet hex coûte 2 hex de déplacement.\r\n- Quitter ce terrain, ou se rendre d’une colline escarpée à une autre, ne coûte que 1 hex de déplacement.\r\n- \\* S’applique uniquement aux unités situées plus bas.\r\n- \\** Bloque la ligne de vue, sauf entre les unités se trouvant sur une hauteur de 1 ou plus.",
        B2: "![def](Terrains Cards/Def/inf-1_b.png)![def](Terrains Cards/Def/arm-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 14,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "VILLES & VILLAGES",
      subtitle: "VILLES & VILLAGES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter14-Towns Villages_Villes Villages-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 15,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BARBELÉS",
      subtitle: "BARBELÉS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter15-Wire_Barbeles-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Une infanterie se trouvant sur un hex avec des barbelés subit un malus de 1 dé à ses attaques.\r\n- Une infanterie peut retirer les barbelés situés sur son hex au lieu d’attaquer. \r\n- Une unité blindée se déplaçant (hors retraites) sur des barbelés peut les retirer et ensuite attaquer.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 16,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "AÉRODROME",
      subtitle: "AÉRODROME",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter16-Airfields_Aerodrome-1-M44TP.png)",
        B1: "- Lorsque l’on applique les règles de l’Air Pack, des avions peuvent y atterrir / en décoller.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 17,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BARAQUEMENTS",
      subtitle: "BARAQUEMENTS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter17-Barracks_Baraquements-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 18,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CIMETIÈRE",
      subtitle: "CIMETIÈRE",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter18-Cemeteries_Cimetieres-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "*Pas de règle spéciale supplémentaire*",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 19,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ÉGLISE",
      subtitle: "ÉGLISE",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter19-Churches_Eglises-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 20,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BARRAGES",
      subtitle: "BARRAGES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter20-Dams_Barrages-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Infranchissables pour toutes les unités sauf l’infanterie.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 21,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "COMPLEXE INDUSTRIEL",
      subtitle: "COMPLEXE INDUSTRIEL",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter21-Factory Complex_Complexe Industriel-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Infranchissables pour toutes les unités sauf l’infanterie.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 22,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CASEMATE",
      subtitle: "CASEMATE",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter22-Field Bunkers_Casemate-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Infranchissable pour toutes les unités sauf l’infanterie.\r\n- Les unités dans un bunker peuvent tirer dans toutes les directions.\r\n- Les blindés et artilleries qui débutent dans un bunker ne peuvent pas se replier ; chaque drapeau qui n’est pas ignoré leur inflige une perte.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 23,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CHAMPS INONDÉS",
      subtitle: "CHAMPS INONDÉS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter23-Flooded Fields_Champs Inondes-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt_b.png)",
        B1: "- Pour se déplacer, ou faire une prise de terrain sur un hex de champs inondés, une unité doit avoir démarré son tour sur un hex adjacent.\r\n- Une unité qui quitte un hex de champs inondés doit s’arrêter dans l’hex adjacent qu’il a rejoint et arrêter son déplacement pour ce tour. La prise de terrain reste toutefois possible. \r\n- \\* blindés seulement. Les unités blindées ne peuvent pas attaquer lors du tour pendant lequel ils **entrent ou sortent** de champs inondés. Si des blindés attaquent une unité se trouvant dans des champs inondés, ils peuvent faire une ***prise de terrain***, mais pas de ***percée***.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 24,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FORTERESSE",
      subtitle: "FORTERESSE",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter24-Fortresses_Forteresses-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag_b.png)",
        B1: "- Infranchissable pour toutes les unités sauf l’infanterie.\r\n- Lorsque les règles *Évasion de prisonniers* s’appliquent, référez-vous à la carte [Actions 7](actions-7).\r\n- \\* Une unité dans une forteresse peut ignorer **tous les drapeaux**.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 25,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "DIGUES & HAUTEURS",
      subtitle: "DIGUES & HAUTEURS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter25-High Ground_Digues Hauteurs-M44TP.png)",
        B1: "- Dans les scénarios avec des champs inondés, les hex de digues & hauteurs sont utilisés pour identifier les zones de terrain ouvert sec, qui ont les mêmes effets que les hex de plaines standard dans un scénario classique. De plus, les hex de [collines](terrain-6), [routes](terrain-42), voies ferrées, [villes et villages](terrain-14) sont tous considérés comme des hauteurs, tout en conservant leurs effets propres.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 26,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "LACS",
      subtitle: "LACS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter26-Lake_Lacs-1-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los_b.png)",
        B1: "- Infranchissables pour toutes les unités.\r\n- \\* La ligne de vue est bloquée par deux hex de lac adjacents (ou plus).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 27,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PHARE",
      subtitle: "PHARE",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter27-Lighthouses_Phare-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 28,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "MARÉCAGES",
      subtitle: "MARÉCAGES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter28-Marshes_Marecages-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt_b.png)",
        B1: "- Infranchissables pour l’artillerie.\r\n- Une unité quittant ce terrain doit stopper et ne peut plus bouger lors de ce tour. La *prise de terrain* reste toutefois possible.\r\n- \\* blindés seulement. Les unités blindées ne peuvent pas attaquer lors du tour pendant lequel ils **entrent ou sortent** de marécages. Si des blindés attaquent une unité se trouvant dans des marécages, ils peuvent faire une ***prise de terrain***, mais pas de ***percée***.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 29,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CHAMPS DE MINES",
      subtitle: "CHAMPS DE MINES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter29-Minefields_Champs de Mines-1-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Piochés au hasard parmi tous les pions de mines disponibles puis mis en place par le joueur les contrôlant, avant la bataille.\r\n- Quand une unité amie s’y déplace : le pion n’est pas révélé.\r\n- Quand une unité ennemie s’y déplace : le pion est révélé. Lancez autant de dés que la valeur du pion et l’unité subit une perte pour chaque symbole de cette unité et chaque grenade. Un leurre (valeur 0) est retiré, les autres restent en place, face visible.\r\n- Se replier dans ou au travers des champs de mine ne les déclenche pas.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 30,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "MONTAGNES",
      subtitle: "MONTAGNES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter30-Moutains_Montagnes-2-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Hauteur : 2**\r\n- Infranchissable pour toutes les unités sauf l’infanterie.\r\n- L’artillerie en montagne attaque à : \r\n3/3/2/2/1/1/1\r\n- \\* S’applique uniquement aux unités situées plus bas.\r\n- \\** Bloque la ligne de vue, sauf entre les unités se trouvant sur une hauteur de 2 ou plus.",
        B2: "![def](Terrains Cards/Def/inf-2_b.png)![def](Terrains Cards/Def/arm-2_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 31,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "OASIS",
      subtitle: "OASIS",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter31-Oasis-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Lorsque les règles *Soins dans l’oasis* s’appliquent, référez-vous à la carte [Actions 10](actions-10).",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 32,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PALMERAIE",
      subtitle: "PALMERAIE",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter32-Palm Forests_Palmeraie-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "*Pas de règle spéciale supplémentaire*",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 33,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PONT FLOTTANT",
      subtitle: "PONT FLOTTANT",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter33-Pontoon Bridges_Pont Flottant-M44TP.png)",
        B1: '- Peut uniquement être construit lorsque stipulé en règle spéciale.\r\n- Pour construire un pont flottant, jouez une carte "Attaque" sans activer les unités et placez le pont flottant sur un hex de [rivière](terrain-8) de la section correspondante à la carte.\r\n- Les ponts flottants suivent les mêmes règles que les [ponts](terrain-9).',
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 34,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CENTRALE ÉLECTRIQUE",
      subtitle: "CENTRALE ÉLECTRIQUE",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter34-Power Plants_Centrale Electrique-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 35,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CAMP DE PRISONNIER",
      subtitle: "CAMP DE PRISONNIER",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter35-Prison Camps_Camp de Prisonniers-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.\r\n- Lorsque les règles *Évasions de prisonniers* s’appliquent, référez-vous à la carte [Actions 7](actions-7).",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 36,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "STATION RADAR",
      subtitle: "STATION RADAR",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter36-Radar Stations_Station Radar-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 37,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PONT FERROVIAIRE",
      subtitle: "PONT FERROVIAIRE",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter37-Railroad Bridges_Pont Ferroviaire-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop_b.png)",
        B1: "- \\* S’applique uniquement aux blindés et à l’artillerie (pas de restriction de mouvement pour l’infanterie). Les blindés peuvent faire une ***prise de terrain*** et une ***percée*** vers / depuis un hex de pont ferroviaire.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 38,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "VOIES FERRÉES",
      subtitle: "VOIES FERRÉES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter38-Railroad Tracks_Voies Ferrees-2-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop_b.png)",
        B1: "- Une route croisant une voie ferrée est considérée comme une [route](terrain-42).\r\n- \\* S’applique uniquement aux blindés et à l’artillerie (pas de restriction de mouvement pour l’infanterie). Les blindés peuvent faire une ***prise de terrain*** et une ***percée*** vers / depuis un hex de voies ferrées.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 39,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "GARE",
      subtitle: "GARE",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter39-Railroad Station_Gare-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Un train entrant en gare n’est pas obliger de stopper.\r\n- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 40,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "OBSTACLE ROUTIER",
      subtitle: "OBSTACLE ROUTIER",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter40-Road Blocks_Obstacle Routier-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Infranchissable pour toutes les unités sauf l’infanterie.",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 41,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "GUÉS & RIVIÈRES GUÉABLES",
      subtitle: "GUÉS & RIVIÈRES GUÉABLES",
      titleSize: 1,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter41-Fords Fordable Rivers_Gues Riviers Gueables-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Les unités se trouvant sur ces terrains subissent un malus de 1 dé à leurs attaques.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 42,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ROUTES",
      subtitle: "ROUTES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter42-Roads_Routes-1-M44TP.png)",
        B1: "- Une unité qui débute son mouvement sur une route et qui reste sur des hexs de route peut se déplacer d’un hex supplémentaire.\r\n- Pour les hex de colline avec route, les règles de [collines](terrain-6) s’appliquent pour les protections de terrain et les lignes de mire.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 43,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "DÉPÔTS DE RAVITAILLEMENT",
      subtitle: "DÉPÔTS DE RAVITAILLEMENT",
      titleSize: 1,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter43-Supply Depots_Depot de Ravitaillement-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)",
        B1: "- Lorsque les règles *Destruction de dépôts* s’appliquent, référez-vous à la carte [Actions 14](actions-14).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 44,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "OUEDS & DÉFILÉS",
      subtitle: "OUEDS & DÉFILÉS",
      titleSize: 2,
      template: 9,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter44-Wadis Gullies_Oueds Defiles-1-M44TP.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Les berges sont infranchissables. Les unités ne peuvent y entrer ou sortir que par les passages ouverts.\r\n- Pour attaquer une unité située sur ces terrains, toutes les unités (à part l’artillerie) doivent se trouver sur un hex adjacent.\r\n- Une unité située sur ces terrains ne peut attaquer que des unités ennemies adjacentes.",
        B2: "![def](Terrains Cards/Def/art-1.png)",
        B3: "![def](Terrains Cards/Def/arm-1.png)\r\n![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 45,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RUINES URBAINES",
      subtitle: "RUINES URBAINES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter45-City Ruins_Ruines-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Infranchissables pour toutes les unités sauf l’infanterie.",
        B2: "![def](Terrains Cards/Def/inf-1.png)![def](Terrains Cards/Def/arm-2.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 46,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "DENTS DE DRAGON",
      subtitle: "DENTS DE DRAGON",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter46-Dragon s Teeth_Dents de Dragon-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Infranchissables pour toutes les unités sauf l’infanterie.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 47,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RIVIÈRE GELÉE",
      subtitle: "RIVIÈRE GELÉE",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter47-Frozen River_Riviere Gelee-1-M44EF.png)",
        B1: "- Une rivière gelée peut être traversée, mais il y a un risque : après qu’une unité s’est déplacée, ou s’est repliée, sur une rivière gelée, lancez 2 dés ; pour chaque étoile obtenue, l’unité subit une perte.\r\n- Une unité éliminée traversant une rivière gelée compte comme une médaille pour le joueur adverse.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 48,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "FORÊTS SUR COLLINES",
      subtitle: "FORÊTS SUR COLLINES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter48-Hills with Forest_Forets sur Collines-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- **Hauteur : 1**",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 49,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "VILLAGES SUR COLLINES",
      subtitle: "VILLAGES SUR COLLINES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter49-Hills with Villages_Villages sur Collines-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- **Hauteur : 1**\r\n- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 50,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RAVINS",
      subtitle: "RAVINS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter50-Ravines_Ravins-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/flag.png)",
        B1: "- Infranchissables pour toutes les unités sauf l’infanterie.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 51,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "TRANCHÉES",
      subtitle: "TRANCHÉES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter51-Trenches_Tranchees-M44EF.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/flag_b.png)",
        B1: "- Infranchissables pour l’artillerie.\r\n- Les blindés se trouvant sur un hex de tranchées ne peuvent pas attaquer.\r\n- \\* L’infanterie peut ignorer un drapeau, mais pas les blindés.",
        B2: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 52,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CAVERNES DE COLLINES",
      subtitle: "CAVERNES DE COLLINES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter52-Caves on Hills_Cavernes de Collines-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Hauteur : 1**\r\n- Infranchissables pour toutes les unités sauf l’infanterie.\r\n-L’infanterie japonaise peut, au coût de l’intégralité de son mouvement, se déplacer d’un hex de cavernes à un autre. Lorsqu’elle est attaquée, elle **doit** ignorer **tous** les drapeaux.\r\n- Une infanterie alliée présence sur ce terrain peut, au lieu d’attaquer, tenter de [combler la caverne](actions-37).\r\n- \\* Ne s’applique qu’aux unités japonaises. Pour les autres, le terrain est considéré comme une [colline](terrain-6) normale.\r\n- \\** Les règles des [collines](terrain-6) s’appliquent pour les lignes de vue.",
        B2: "![def](Terrains Cards/Def/arm-2_b.png)![def](Terrains Cards/Def/inf-2_b.png)!",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 53,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CAVERNES DE MONTAGNES",
      subtitle: "CAVERNES DE MONTAGNES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter53-Caves on Mountains_Cavernes de Montagnes-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Hauteur : 2**\r\n- Infranchissables pour toutes les unités sauf l’infanterie.\r\n-L’infanterie japonais peut, au coût de l’intégralité de son mouvement, se déplacer d’un hex de cavernes à un autre. Lorsqu’elle est attaquée, elle **doit** ignorer **tous** les drapeaux.\r\n- Une infanterie alliée présence sur ce terrain peut, au lieu d’attaquer, tenter de [combler la caverne](actions-37).\r\n- \\* Ne s’applique qu’aux unités japonaises. Pour les autres, le terrain est considéré comme une [colline](terrain-6) normale.\r\n- \\** Les règles de [montagnes](terrain-30) s’appliquent pour les lignes de vue.",
        B2: "![def](Terrains Cards/Def/arm-2_b.png)![def](Terrains Cards/Def/inf-2_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 54,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "TROUS D’EAU",
      subtitle: "TROUS D’EAU",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter54-Fish Ponds_Trous d eau-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)",
        B1: "- Infranchissables pour l’artillerie.\r\n- L’infanterie y entrant ne peut pas combattre ce tour.\r\n- Les blindés y entrant *ou en sortant* ne peuvent pas combattre ce tour.\r\n- Une unité quittant ce terrain doit stopper et ne peut plus bouger lors de ce tour. La *prise de terrain* reste toutefois possible.\r\n- Si des blindés attaquent une unité se trouvant dans un trou d’eau, ils peuvent faire une ***prise de terrain***, mais pas de ***percée***.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 55,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "HÔPITAL",
      subtitle: "HÔPITAL",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter55-Hospitals_Hopital-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)",
        B1: "- Lorsque les règles *Soins hospitaliers* s’appliquent, référez-vous à la carte [Actions 18](actions-18).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 56,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "QUARTIER GÉNÉRAL DE CAMPAGNE",
      subtitle: "QUARTIER GÉNÉRAL DE CAMPAGNE",
      titleSize: 1,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter56-HQ Supply Tents_QG de campagne-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)",
        B1: "- Lorsque les règles *Capture du quartier général de campagne* s’appliquent, référez-vous à la carte [Actions 17](actions-17).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 57,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "JUNGLES",
      subtitle: "JUNGLES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter57-Jungles-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt_b.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- \\* Une unité peut attaquer après s’être déplacée dans un hex de jungle si elle a démarré son déplacement dans un hex adjacent. Si une unité de blindés démarre son déplacement dans un hex de jungle adjacent à sa cible, elle peut y faire une ***prise de terrain*** et une ***percée***.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 58,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CAMP DE TRAVAIL",
      subtitle: "CAMP DE TRAVAIL",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter58-Labor Camps_Camp de Travail-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 59,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "QUAI",
      subtitle: "QUAI",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter59-Piers_Quai-M44PT.png)",
        B1: "- Un déplacement sur un hex de quai ne peut se faire que depuis la terre ou la plage, jamais depuis la mer.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 60,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RIZIÈRES",
      subtitle: "RIZIÈRES",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter60-Rice Paddies_Rizieres-M44PT.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt_b.png)",
        B1: "- Infranchissables pour l’artillerie.\r\n- Une unité quittant ce terrain doit stopper et ne peut plus bouger lors de ce tour. La *prise de terrain* reste toutefois possible.\r\n- \\* blindés seulement. Les unités blindées ne peuvent pas attaquer lors du tour pendant lequel ils **entrent ou sortent** d’une rizière. Si des blindés attaquent une unité se trouvant dans une rizière, ils peuvent faire une ***prise de terrain***, mais pas de ***percée***.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 61,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "RUISSEAUX & RIVIÈRES FRANCHISSABLES",
      subtitle: "RUISSEAUX & RIVIÈRES FRANCHISSABLES",
      titleSize: 1,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter61-Fordable Streams_Ruisseaux et Rivieres Franchissables-M44.png)",
        A2: "![IC](Terrains Cards/Icones/stop_b.png)",
        B1: "- \\* Après s’être déplacé sur ce type de terrain, une unité **doit** stopper, mais les ***prises de terrain*** et les ***percées*** restent possibles.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 62,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "PONT DE CORDE",
      subtitle: "PONT DE CORDE",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter62-Rope Bridges_Pont de Corde-M44PT.png)",
        B1: "- Les unités peuvent utiliser des ponts de corde pour entrer sur un hex de [fleuve ou rivière](terrain-8).\r\n- Les ponts de corde suivent les mêmes règles que les [ponts](terrain-9).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 63,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ESCARPEMENTS ROCHEUX",
      subtitle: "ESCARPEMENTS ROCHEUX",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter63-Escarpments_Escarpements Rocheux-M44MT.png)",
        A2: "![IC](Terrains Cards/Icones/los.png)",
        B1: "- **Hauteur : 1**\r\n- Infranchissable pour toutes les unités.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 64,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ERGS & DUNES",
      subtitle: "ERGS & DUNES",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter64-Ergs Ridges_Dunes-M44MT.png)",
        A2: "![IC](Terrains Cards/Icones/stop_b.png)![IC](Terrains Cards/Icones/los_c.png)",
        B1: "- **Hauteur : 1**\r\n- \\* S’applique uniquement aux unités se déplaçant ou attaquant depuis un hex situé plus bas.\r\n- \\** Bloque la ligne de vue, sauf entre les unités se trouvant sur une hauteur de 1 ou plus.",
        B2: "![def](Terrains Cards/Def/arm-1_b.png)![def](Terrains Cards/Def/inf-1_b.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 65,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "BALKAS",
      subtitle: "BALKAS",
      titleSize: 2,
      template: 9,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter65-Balkas-2-M44SS.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Une unité y entrant ou en sortant doit s’arrêter et ne peut bouger lors de ce tour.\r\n- Une unité peut passer d’un balka à un pont, et inversement, mais doit alors s’arrêter.\r\n- Une unité se trouvant sur un hex de balka subit un malus de 1 dé à ses attaques.",
        B2: "![def](Terrains Cards/Def/art-1.png)",
        B3: "![def](Terrains Cards/Def/arm-1.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 66,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "ABATIS",
      subtitle: "ABATIS",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter66-Abatis_Abattis-1-M44CB1.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)",
        B1: "- Infranchissables pour toutes les unités sauf l’infanterie.\r\n- L’infanterie se trouvant sur ce terrain subit un malus de 1 dé à ses attaques.\r\n- Une infanterie peut retirer l’abatis situés sur son hex au lieu d’attaquer.",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 67,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "CHÂTEAU",
      subtitle: "CHÂTEAU",
      titleSize: 2,
      template: 8,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter67-Castle_Chateau-M44DD.png)",
        A2: "![IC](Terrains Cards/Icones/stop.png)![IC](Terrains Cards/Icones/noatt.png)![IC](Terrains Cards/Icones/los.png)",
        B1: "- Les blindés se trouvant sur ce terrain subissent un malus de 2 dés à leurs attaques.",
        B2: "![def](Terrains Cards/Def/arm-2.png)![def](Terrains Cards/Def/inf-1.png)",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "terrain",
      id: 68,
      background: "Terrains Cards/Autres/73-M44V2-Cards-Helpers-Terrains.png",
      title: "LITTORAL",
      subtitle: "LITTORAL",
      titleSize: 2,
      template: 7,
      slots: {
        A1: "![Terrain](Terrains Cards/Illustrations Terrains/73-Ter68-Coastline_Littoral-1-M44MT.png)",
        B1: "- Entrer dans un hex de littoral limite le déplacement maximal d’une unité à 2 hex pour le tour en cours.\r\n- Une [colline](terrain-6) adjacente à un hex de littoral est considéré comme étant une [falaise](terrain-11).",
      },
      titleBackground:
        "Terrains Cards/Autres/73-M44V2-Cards-Helpers-CartoucheTerrains.png",
    },
    {
      type: "troops",
      id: 1,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "UNITÉS STANDARD",
      subtitle: "UNITÉS STANDARD",
      titleSize: 2,
      template: 1,
      slots: {
        A1: "**INFANTERIE**\n![tro01a](Troops Cards/tro01a1.png)",
        A2: "**BLINDÉS**\n![tro01b](Troops Cards/tro01a2.png)",
        A3: "**ARTILLERIE**\n![tro01c](Troops Cards/tro01a3.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png)\r\n- Se déplace de 0-1 hex et attaque ou se déplace de 2 hex sans attaquer.\r\n- Peut effectuer une ***prise de terrain*** après une attaque en combat rapproché décisive.",
        B2: "![arm333](Troops Cards/73-M44-Cards-troopattack_arm333.png)\r\n- Se déplace de 0-3 hex et attaque. \r\n- Peut effectuer une ***prise de terrain*** après une attaque en combat rapproché décisive, puis faire une ***percée***.",
        B3: "![art332211](Troops Cards/73-M44-Cards-troopattack_art332211.png)\r\n- Se déplace de 1 hex ***ou*** attaque. \r\n- Ignore les lignes de vue et les protections des terrains.\r\n- Ne peut pas faire de prise de terrain.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 2,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "UNITÉS SPÉCIALISÉES",
      subtitle: "UNITÉS SPÉCIALISÉES",
      titleSize: 2,
      template: 2,
      slots: {
        A1: "**INFANTERIE D'ÉLITE**\n![tro02a](Troops Cards/tro02a1.png)",
        A2: "**BLINDÉS D'ÉLITE**\n![tro02b](Troops Cards/tro02a2.png)",
        B1: "- Se déplace de 0-2 hex et attaque.",
        B2: "- 4 figurines par unité.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 3,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "ARTILLERIE LOURDE",
      subtitle: "ARTILLERIE LOURDE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro03](Troops Cards/tro03a1.png)",
        B1: "![art33221111](Troops Cards/73-M44-Cards-troopattack-art33221111.png)\r\n- Après qu’une attaque de cette unité a infligé au moins une perte, placez un pion cible sur l’unité visée pour la marquer. L’unité reste marquée tant qu’elle ne s’est pas déplacée. Si l’artilerie lourde se déplace, tous les pions cible sont retirés. L’artillerie lourde attaque les unités marquées avec 1 dé supplémentaire.\r\n- Les pions cible ne sont pas cumulables.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 4,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TROUPES DU GÉNIE",
      subtitle: "TROUPES DU GÉNIE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro04](Troops Cards/tro04a1.png)",
        B1: "- En combat rapproché, ignorent les protections des terrains.\r\n- Dans les barbelés, peuvent attaquer avec un malus de 1 dé **et** enlever les barbelés.\r\n- Dans un champ de mines, **doivent** déminer au lieu d’attaquer.\r\n- Si activées par *Assaut d’infanterie*, peuvent se déplacer de 2 hex et enlever des barbelés ou déminer.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 5,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TRAINS",
      subtitle: "TRAINS",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![tro05](Troops Cards/tro05a1.png)",
        B1: "- Activés comme une seule unité.\r\n- Se déplacent de 1-3 hex, en avant / arrière, si la voie ferrée est libre.\r\n- Battent en retraite dans le sens opposé au sens de marche de la locomotive.\r\n- Peuvent ignorer 1 drapeau.\r\n- Ne sont touchés que par un symbole grenade.\r\n- Le wagon est détruit au 3e coup au but, la locomotive au 4e coup au but.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 6,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TRAIN DE RAVITAILLEMENT",
      subtitle: "TRAIN DE RAVITAILLEMENT",
      titleSize: 1,
      template: 5,
      slots: {
        A1: "- Peut transporter des unités d’infanterie ou de blindés en renfort.\r\n- Une unité transportée sur le train ne peut pas combattre.\r\n- Quand une locomotive est en gare, les unités sont déployées sur les hex adjacents à la locomotive et au wagon.",
        A2: "![tro06](Troops Cards/tro06a2.png)",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 7,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TRAIN BLINDÉ",
      subtitle: "TRAIN BLINDÉ",
      titleSize: 2,
      template: 5,
      slots: {
        A1: "Un train blindé transporte 1 figurine d’artillerie sur son wagon :\r\n- Le train peut se déplacer **et** l’artillerie peut attaquer.\r\n- L’artillerie sur wagon tire comme une artillerie normale.\r\n- L’artillerie sur wagon est détruite quand le wagon est détruit (3e coup au but).",
        A2: "![tro07](Troops Cards/tro07a2.png)",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 8,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "CAVALERIE",
      subtitle: "CAVALERIE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro08](Troops Cards/tro08a1.png)",
        B1: "![inf21](Troops Cards/73-M44-Cards-troopattack_inf21.png)\r\n- 4 figurines.\r\n- Activée comme de l’infanterie.\r\n- Se déplace de 0-3 hex et attaque.\r\n- Après une attaque en combat rapproché décisive, peut faire une ***prise de terrain*** puis faire une ***percée***.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 9,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TROUPES À SKI",
      subtitle: "TROUPES À SKI",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro09](Troops Cards/tro09a1.png)",
        B1: "![inf32](Troops Cards/73-M44-Cards-troopattack_inf32.png)\r\n- 3 figurines.\r\n- Se déplacent de 0-3 hex et attaquent.\r\n- Peuvent attaquer après s’être déplacées sur n’importe quel type de terrain, mais doivent respecter les restrictions de mouvement des terrains.\r\n- Peuvent se replier de 1 à 3 hex par drapeau.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 10,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TIREUR D’ÉLITE",
      subtitle: "TIREUR D’ÉLITE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro10](Troops Cards/tro10a1.png)",
        B1: "![inf32](Troops Cards/73-M44-Cards-troopattack_inf11111.png)\r\n- 1 figurine.\r\n- Se déplace de 0-2 et attaque ; peut se replier de 1 à 3 hex par drapeau.\r\n- Peut attaquer après s’être déplacé sur n’importe quel type de terrain, mais doit respecter les restrictions de mouvement des terrains.\r\n- Ne peut pas attaquer les unités blindées.\r\n- Ignore les protections des terrains et inflige une perte sur une le symbole de l’unité visé, grenade ou étoile.\r\n- Touché uniquement sur grenade (et étoile dans certains cas).\r\n- Ne rapporte pas de médaille de victoire.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 11,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "PORTE-AVIONS",
      subtitle: "PORTE-AVIONS",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![tro11](Troops Cards/tro11a1.png)",
        B1: "- Lorsqu’on applique les règles aériennes, des avions peuvent y atterrir / en décoller.\r\n- Se déplace de 0-2 hex d’océan.\r\n- Ne peut se déplacer dans un hex adjacent à un hex de plage.\r\n- Touché uniquement sur grenade. Coule au 3e coup au but.\r\n- Peut ignorer 1 drapeau, subit un coup au but s’il ne peut pas battre en retraite.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 12,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "DESTROYERS",
      subtitle: "DESTROYERS",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![tro012](Troops Cards/tro12a1.png)",
        B1: "![dest33221111](Troops Cards/73-M44-Cards-troopattack_dest33221111.png)\r\n- Se déplace de 0-2 hex d’océan et attaque.\r\n- Ne peut se déplacer dans un hex adjacent à un hex de plage.\r\n- Touché uniquement sur grenade. Coule au 3e coup au but.\r\n- Peut ignorer 1 drapeau, subit un coup au but s’il ne peut pas battre en retraite.\r\n- Après qu’une attaque a infligé au moins une perte, placez un pion cible sur l’unité visée pour la marquer. L’unité reste marquée tant qu’elle ne s’est pas déplacée. Si le destroyer se déplace, tous les pions cible sont retirés. Le destroyer attaque les unités marquées avec 1 dé supplémentaire.\r\n- Les pions cible ne sont pas cumulables.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 13,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "BLINDÉS LANCE-FLAMMES",
      subtitle: "BLINDÉS LANCE-FLAMMES",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![tro13](Troops Cards/tro13a1.png)",
        B1: "![arm333](Troops Cards/73-M44-Cards-troopattack_arm333.png)\r\n- Se déplacent de 0-3 et attaquent.\r\n- La protection du terrain de l’unité attaquée ne peut pas excéder 1 dé en combat rapproché.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 14,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "ARTILLERIE MOBILE",
      subtitle: "ARTILLERIE MOBILE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro14](Troops Cards/tro14a1.png)",
        B1: "![art332211](Troops Cards/73-M44-Cards-troopattack-art33221111.png)\r\n- Se déplace de 0-1 hex et attaque, ou de 2 hex sans attaquer.\r\n- Ignore la ligne de vue et les protections des terrains.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 15,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "BARGES (LC)",
      subtitle: "BARGES (LC)",
      titleSize: 2,
      template: 4,
      slots: {
        A1: "![tro15](Troops Cards/tro15a1.png)",
        B1: "- Démarrent avec une unité à bord.\r\n- Se déplacent de 1-2 hex, jamais sur des obstacles antichars.\r\n- Sont retirées une fois les unités débarquées sur la plage.\r\n- Une unité dans une barge est attaquée de manière normale, peut se replier sur des hex d’océan, et ne peut pas attaquer, y compris lors du tour où elle débarque.\r\n- Si l’unité embarquée est éliminée, la barge est également retirée (sans médaille supplémentaire).",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 16,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "TIGRES",
      subtitle: "TIGRES",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro16](Troops Cards/tro16a1.png)",
        B1: "![arm333](Troops Cards/73-M44-Cards-troopattack_arm333.png)\r\n- 1 figurine.\r\n- Se déplace de 0-3 hex et attaque.\r\n- Lorsque le Tigre est touché, l’adversaire relance les dés qui ont touché (qui incluent les drapeaux si le Tigre est incapable de se replier). S’il obtient au moins une grenade, le Tigre est détruit. Tous les autres résultats sont ignorés. S’il n’est pas détruit, les règles normales de retraite s’appliquent pour tout drapeau obtenu lors du premier lancer et qui n’a pas été relancé.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 17,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "CAMIONS DE TRANSPORT",
      subtitle: "CAMIONS DE TRANSPORT",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![tro17](Troops Cards/tro17a1.png)",
        B1: "- 1 à 3 figurines selon le scenario.\r\n- Considérés comme de l’infanterie dans tous les cas.\r\n- Se déplacent de 0-2 hex, +2 hex sur route ; ne peuvent pas attaquer.\r\n- Lorsqu’ils sont activés, peuvent [renforcer l’effectif](actions-24) de toute unité amie adjacente qui a subi des pertes.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 18,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "HALF-TRACKS",
      subtitle: "HALF-TRACKS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro18](Troops Cards/tro18a1.png)",
        B1: "![arm22](Troops Cards/73-M44-Cards-troopattack_arm22.png)\r\n- Se déplacent de 0-2 hex et attaquent.\r\n- 1 à 3 figurines selon le scenario.\r\n- Considérés comme des blindés dans tous les cas.\r\n- Après une attaque en combat rapproché décisive, peuvent faire une ***prise de terrain*** mais pas de ***percée***.\r\n- Lorsqu’ils sont activés, peuvent [renforcer l’effectif](actions-24) de toute unité amie adjacente qui a subi des pertes au lieu de combattre.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 19,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "VOITURES TOUT-TERRAIN",
      subtitle: "VOITURES TOUT-TERRAIN",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![tro19](Troops Cards/tro19a1.png)",
        B1: "![tru321](Troops Cards/73-M44-Cards-troopattack_tru321.png)\r\n- Se déplacent de 0-4 et attaquent.\r\n- 1 à 3 figurines selon le scenario.\r\n- Considérées comme de l’infanterie dans tous les cas.\r\n- Lorsque l’unité est touchée, l’adversaire relance les dés qui ont touché ; pour chaque grenade obtenue lors de ce 2e jet, l’unité perd une figurine. Tous les autres résultats sont ignorés. Les règles normales de retraite s’appliquent ensuite pour tout drapeau obtenu lors du premier lancer et qui n’a pas été relancé.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 20,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "VOITURES DE COMMANDEMENT",
      subtitle: "VOITURES DE COMMANDEMENT",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![tro20](Troops Cards/tro20a1.png)",
        B1: "- Se déplacent de 0-3 hex ; ne peuvent pas attaquer.\r\n- 1 figurine,\r\n- Considérées comme de l’infanterie dans tous les cas.\r\n- Lorsque l’unité est touchée, l’adversaire relance les dés qui ont touché. S’il obtient au moins une grenade, l’unité est détruite. Tous les autres résultats sont ignorés. S’il n’est pas détruit, les règles normales de retraite s’appliquent pour tout drapeau obtenu lors du premier lancer et qui n’a pas été relancé.\r\n- Si vous jouez une carte section correspondant à celle dans laquelle se trouve la voiture de commandement, activez une unité supplémentaire dans cette section.\r\n- Si vous jouez une *Reconnaissance 1* pour activer la voiture de commandement, vous pouvez, au lieu de piocher deux cartes pour en garder une, prendre une carte dans la défausse.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 21,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "BRANDENBURGERS",
      subtitle: "BRANDENBURGERS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro21](Troops Cards/tro21a1.png)",
        B1: "- 3 figurines + 1 figurine ennemie.\r\n- Si l’unité est touchée, l’adversaire relance 1 dé. S’il n’obtient pas un symbole infanterie, le 1er lancer est ignoré et l’unité ne subit aucune perte.\r\n- S’il obtient un symbole d’infanterie, la figurine ennemie est retirée et le lancer initial est appliqué normalement.\r\n- Dès que les Brandenburgers attaquent, retirez la figurine ennemie de leur unité.\r\n- Une unité de Brandenburgers qui a perdu sa figurine ennemie se comporte comme une infanterie d’élite.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 22,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "UNITÉS INCOMPLÈTES",
      subtitle: "UNITÉS INCOMPLÈTES",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro22](Troops Cards/tro22a1.png)",
        B1: "- Une unité incomplète a toujours moins de figurines qu’une unité normale.\r\n- Une unité incomplète ne peut jamais regagner plus de figurines qu’elle n’en avait au début du scénario.\r\n- Une unité incomplète se déplace et combat normalement, mais elle ne rapporte pas de médaille de victoire si elle est éliminée ou si elle quitte le champ de bataille.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 23,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "CANONS ANTICHARS LOURDS",
      subtitle: "CANONS ANTICHARS LOURDS",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![tro23](Troops Cards/tro23a1.png)",
        B1: "![art2222](Troops Cards/73-M44-Cards-troopattack_art2222.png)\r\n- Se déplacent de 1 hex **ou** attaquent.\r\n- Considérés comme de l’artillerie dans tous les cas.\r\n- Infligent une perte sur étoile quand ils attaquent une unité blindée ou de véhicules.\r\n- Ignorent les protections des terrains.\r\n- Doivent avoir une ligne de vue vers leur cible.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 24,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "CHASSEURS DE CHARS",
      subtitle: "CHASSEURS DE CHARS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro24](Troops Cards/tro24a1.png)",
        B1: "![arm2222](Troops Cards/73-M44-Cards-troopattack_arm2222.png)\r\n- Se déplacent de 0-2 hex et attaquent.\r\n- 3 figurines (4 pour les Allemands et les Soviétiques)\r\n- Considérés comme des blindés dans tous les cas.\r\n- Subit une perte sur étoile quand ils sont attaqués par toute unité autre que l’infanterie.\r\n- Infligent une perte sur étoile quand ils attaquent une unité blindée ou de véhicules.\r\n- Ignorent les protections des terrains s’ils n’ont pas bougé lors du tour.\r\n- Après une attaque en combat rapproché décisive, peuvent faire une ***prise de terrain***, mais pas de ***percée***.\r\n- Peuvent se replier de 1 à 2 hex par drapeau.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 25,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "NEBELWERFER",
      subtitle: "NEBELWERFER",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro25](Troops Cards/tro25a1.png)",
        B1: "![art332211](Troops Cards/73-M44-Cards-troopattack-art33221111.png)\r\n- Se déplacent de 1 hex **ou** attaquent.\r\n- Peuvent tirer, au choix du joueur, des obus incendiaires ou fumigènes :\r\n**Obus incendiaires :** aucun drapeau ne peut être ignoré.\r\n**Obus fumigènes :** au lieu d’attaquer, placez trois jetons d’[écran de fumée](actions-21) sur 3 hexs adjacents et à portée de tir.\r\n- Ne bénéficient jamais des protections des terrains.\r\n- Ignorent les lignes de vue et les protections des terrains.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 26,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "FUNNIES DE HOBART",
      subtitle: "FUNNIES DE HOBART",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro26](Troops Cards/tro26a1.png)",
        B1: "- Se déplacent et attaquent comme des blindés standard.\r\n- Avant la partie, remplacez 1 figurine de char par un Churchill AVRE équipé d’un des éléments suivants : **Pont :** peut placer un [pont](terrain-9) sur une [rivière](terrain-8) au lieu de combattre. **Bobine :** ignore les restrictions de terrain des [plages](terrain-1), des [marécages](terrain-28) et des [barbelés](terrain-15) ; retire les [barbelés](terrain-15) quand ils s’arrêtent ou passent dessus. **Fascines :** ignore les restrictions de terrain des [gués](terrain-41) et des [tranchées](terrain-51), et peut attaquer depuis une [tranchée](terrain-51). **Soc démineur :** doit s’arrêter s’il pénètre sur un [champ de mines](terrain-29), mais peut retirer les mines et attaquer normalement. **Mortier “pétard” :** attaque avec 1 dé supplémentaire contre un [bunker](terrain-2) en combat rapproché, et s’il obtient une étoile, le [bunker](terrain-2) est retiré.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 27,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "INFANTERIE SOUTENUE",
      subtitle: "INFANTERIE SOUTENUE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro27](Troops Cards/tro27a1.png)",
        B1: "![supinf321](Troops Cards/73-M44-Cards-troopattack_supinf332.png)\r\n- 4 figurines d’infanterie + 1 figurine de blindé\r\n- Considérées comme de l’infanterie dans tous les cas.\r\n- Après une attaque en combat rapproché décisive, peut faire une ***prise de terrain*** et effectuer une nouvelle attaque sur une unité ennemie adjacente.\r\n- À la 3e perte, la figurine de blindé est retirée, et l’unité devient une unité d’infanterie standard pour le reste de la partie.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 28,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "BLINDÉS SOUTENUS",
      subtitle: "BLINDÉS SOUTENUS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro28](Troops Cards/tro28a1.png)",
        B1: "![suparm333](Troops Cards/73-M44-Cards-troopattack _suparm333.png)\r\n- 3 figurines de blindés + 1 figurine d’infanterie.\r\n- Considérés comme des blindés dans tous les cas.\r\n- Pour leurs attaques en combat rapproché, se voient appliquer les protections de terrain contre l’infanterie au lieu de celles contre les blindés.\r\n- À la 3e perte, la figurine d’infanterie est retirée, et l’unité devient une unité de blindés standard pour le reste de la partie.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 29,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "COMBATTANTS DE JUNGLE",
      subtitle: "COMBATTANTS DE JUNGLE",
      titleSize: 1,
      template: 3,
      slots: {
        A1: "![tro29](Troops Cards/tro29a1.png)",
        B1: "![inf321](Troops Cards/73-M44-Cards-troopattack_inf321.png)\r\n- Ignorent les restrictions de mouvement et les protections des hexs de [jungle](terrain-57).",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 30,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "DRAGONS POLONAIS",
      subtitle: "DRAGONS POLONAIS",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro30](Troops Cards/tro30a1.png)",
        B1: "![inf32](Troops Cards/73-M44-Cards-troopattack_inf32.png)\r\n- 4 figurines.\r\n- Se déplacent de 0-3 attaquent.\r\n- Après une attaque en combat rapproché décisive, peut faire une ***prise de terrain*** puis faire une ***percée***.\r\n- Peuvent ignorer 1 drapeau.\r\n- Peuvent se replier de 1-2 hex par drapeau.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 31,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "AUTOMITRAILLEUSE",
      subtitle: "AUTOMITRAILLEUSE",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro31](Troops Cards/tro31a1.png)",
        B1: "![arm321](Troops Cards/73-M44-Cards-troopattack_arm321.png)\r\n- 1 figurine.\r\n- Se déplace de 0-4 et attaque.\r\n- Considérée comme un blindé pour l’activation et le combat.\r\n- Après une attaque en combat rapproché décisive, peut faire une ***prise de terrain*** puis faire une ***percée***.\r\n- Considérée comme de l’infanterie quand elle est attaquée.\r\n- Lorsqu’elle est touchée, l’adversaire relance les dés qui ont touché. S’il obtient au moins une grenade, l’automitrailleuse est détruite. Tous les autres résultats sont ignorés. Si elle n’est pas détruite, les règles normales de retraite s’appliquent pour tout drapeau obtenu lors du premier lancer et qui n’a pas été relancé.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
    {
      type: "troops",
      id: 32,
      background: "Troops Cards/73-M44V2-Cards-Helpers-TroopsCards-Type0.png",
      title: "CHENILLETTES",
      subtitle: "CHENILLETTES",
      titleSize: 2,
      template: 3,
      slots: {
        A1: "![tro32](Troops Cards/tro32a1.png)",
        B1: "![arm321](Troops Cards/73-M44-Cards-troopattack_arm321.png)\r\n- 2 figurines.\r\n- Considérés comme des blindés dans tous les cas.",
      },
      titleBackground:
        "Troops Cards/73-M44V2-Cards-Helpers-CartoucheTroops.png",
    },
  ],
};
